export default {
    address: {
        city: "Città",
        city_locality: "Città \/ Località",
        country: "Paese",
        line1: "Indirizzo Linea 1",
        line2: "Indirizzo riga 2",
        postal_code: "Codice Postale",
        state: "Stato",
        state_region: "Stato \/ Regione"
    },
    alerts: {
        account_2fa: "Proteggi il tuo account con l'autenticazione a due fattori.",
        account_2fa_success: "L'autenticazione a due fattori è abilitata.",
        activate_instruction: "L'attivazione della raccolta automatica delle recensioni tenterà di richiedere una Recensione da {count}. Visualizza i tuoi modelli prima di abilitarli.",
        activate_intro: "Richiedi continuamente recensioni in base alla tua strategia.",
        agency_mcp_server: "Collega Claude o qualsiasi altro client MCP al server MCP della tua agenzia. Gli assistenti autorizzati potranno gestire per tuo conto i progetti, i clienti e il team della tua agenzia.",
        agency_sso: "Connetti un provider di identità OpenID Connect per l'accesso del client.",
        ai_assistant: "Per utilizzare l'intelligenza artificiale per suggerimenti e risposte alle recensioni, è necessario specificare il nome e la descrizione della tua attività.",
        ai_review_pages: "Consenti i suggerimenti di recensione IA nelle pagine che selezioni.",
        api_key_roll: "Vuoi davvero modificare la tua chiave API ? Questa modifica avrà effetto su tutte le applicazioni che la utilizzano.",
        ask_confirm: "Vuoi davvero richiedere recensioni a {count}? Questo programmerà le richieste per tutti i clienti a cui non è ancora stata fatta alcuna richiesta.",
        automate_highlights: "Evidenzia automaticamente le frasi nelle nuove recensioni positive.",
        automate_replies: "Pubblica automaticamente le risposte IA alle nuove recensioni di Google e Facebook. Richiede un'[integrazione Google o Facebook](\/settings\/integrations?tab=review).",
        cname_delete: "Vuoi davvero rimuovere CNAME: {cname_name}?",
        cname_not_configured: "Questo record non è ancora stato configurato. Attendi...",
        cname_warning: "I messaggi già inviati ai tuoi clienti conterranno link non funzionanti.",
        connection_disabled: "La connessione è disattivata. Riconnettiti.",
        customer_archive: "Vuoi davvero archiviare il cliente: {customer_name}? Tutti i messaggi non inviati verranno annullati.",
        customer_cancel: "Vuoi davvero annullare tutti i messaggi non inviati al cliente: {customer_name}?",
        customer_ingest: "Includi questo indirizzo email nel campo CCN quando invii email ai tuoi clienti, in modo che il loro nome e indirizzo email vengano importati automaticamente.",
        customer_resubscribe: "Sei sicuro di voler reiscrivere il cliente: {customer_name}?",
        customer_unarchive: "Vuoi davvero ripristinare il cliente dall'archivio: {customer_name}?",
        customer_unsubscribe: "Vuoi davvero annullare l'iscrizione del cliente: {customer_name}?",
        customer_unsubscribe_all: "Vuoi davvero annullare l'iscrizione di {count} per non ricevere più messaggi da questo progetto?",
        delete: "Sei sicuro di voler eliminare {model}: {name}?",
        delete_count: "Sei sicuro di voler eliminare {count}",
        domain_agency: "Aggiungi il tuo dominio di invio per dare alla tua agenzia un marchio completamente personalizzato.",
        domain_delete: "Vuoi davvero rimuovere il dominio: {name}? Continueremo a inviare email dal nostro nome di dominio.",
        domain_dmarc: "Aggiungi un record DMARC al tuo dominio per ridurre la possibilità che le email finiscano nello spam.",
        domain_project: "Aggiungi un dominio di invio così potremo inviare email ai tuoi clienti dal tuo nome di dominio.",
        export_confirm: "Sei sicuro di voler esportare tutti i tuoi {model}?",
        export_count: "Sei sicuro di voler esportare {count}?",
        export_link: "Un link per il download verrà inviato a {email} subito dopo aver effettuato la richiesta.",
        highlights_save_disabled: "È possibile, facoltativamente, rimuovere le evidenziazioni da tutte le recensioni che attualmente le presentano.",
        highlights_save_enabled: "Per evidenziare tutte le recensioni positive, seleziona la casella sottostante. Se desideri solo modificare il colore di evidenziazione, lascia la casella deselezionata.",
        integration_disconnect: "Vuoi davvero disconnetterti da {integration_name}?",
        integration_sync: "Vuoi davvero sincronizzare il tuo account {integration_name}? Importeremo continuamente i tuoi dati per te.",
        intro: "Inizia importando i tuoi clienti. Poi invia tu le richieste di recensione, oppure lasciale inviare a noi.",
        intro_help: "Se hai bisogno di aiuto, {demo}.",
        logout: "Sei sicuro di voler effettuare il logout?",
        mcp_server: "Collega Claude o qualsiasi altro client MCP a questo progetto. Il server MCP consente agli assistenti IA di leggere e gestire recensioni, clienti e messaggi per tuo conto.",
        member_confirm: "Sei sicuro di volerti rimuovere? Perderai l'accesso a questo progetto.",
        member_confirm_all: "Sei sicuro di volerti rimuovere? Perderai l'accesso a tutti i tuoi progetti.",
        member_other_confirm: "Vuoi davvero rimuovere {noun}: {name}? Perderanno l'accesso a questo progetto.",
        member_other_confirm_all: "Vuoi davvero rimuovere {noun} {name}? Perderanno l'accesso a tutti i loro progetti.",
        message_cancel: "Sei sicuro di voler annullare questo messaggio?",
        message_cancel_all: "Vuoi davvero annullare {count}? Questa azione può essere eseguita solo sui messaggi non inviati.",
        message_delete: "Sei sicuro di voler eliminare questo messaggio?",
        oauth_client_revoke: "Sei sicuro di voler revocare l'accesso per {client}? Tutte le sessioni attive verranno disconnesse immediatamente.",
        project_summary: "Al momento non è possibile generare un riepilogo.",
        project_suspend: "Sei sicuro di voler sospendere il progetto: {project_name}?",
        project_unsuspend: "Vuoi davvero annullare la sospensione del progetto: {project_name}?",
        review_delete: "Sei sicuro di voler eliminare questa recensione? Questa azione non può essere annullata.",
        review_page_confirm: "Vuoi davvero salvare le modifiche?",
        review_page_confirmation: "Mostra un messaggio di conferma nella pagina di successo in base alla valutazione selezionata.",
        review_page_default: "Vuoi davvero impostare la pagina di Recensione: {name} come pagina predefinita? Questa pagina verrà utilizzata se non è assegnata nessun'altra pagina a una richiesta di Recensione.",
        review_page_delete: "Vuoi davvero eliminare la pagina di recensione: {name}? Tutti i clienti che sono attualmente indirizzati a questa pagina verranno indirizzati alla tua pagina predefinita.",
        review_page_delete_all: "Sei sicuro di voler eliminare {count}? La tua pagina di Recensione predefinita non verrà eliminata.",
        review_page_fields: "Utilizza i campi per acquisire le informazioni del cliente quando lascia una recensione. Aggiungi altri campi al tuo modulo e visualizzali in modo condizionale quando i clienti selezionano una valutazione.",
        review_page_instructions: "Dopo aver selezionato una valutazione, mostra le istruzioni direttamente sopra il modulo.",
        review_page_location_picker: "Lascia che i clienti selezionino qualsiasi posizione nel tuo progetto per la Recensione. Questa sarà preselezionata se la pagina di Recensione è destinata a essere mostrata per una posizione specifica.",
        review_page_locations: "Seleziona le posizioni che devono usare questa pagina di Recensione. Una posizione può essere assegnata solo a una pagina di Recensione. Se a una posizione non ne è assegnata una, utilizzerà la pagina di Recensione predefinita.",
        review_page_redirects: "Salta il modulo dopo aver selezionato una valutazione e reindirizza altrove. Puoi anche dividere il traffico su più siti Web aggiungendo più di un reindirizzamento per ogni valutazione.",
        review_page_review_suggestions: "Aiuta i clienti a scrivere recensioni con suggerimenti pronti all’uso che possono modificare prima di inviare.",
        share_template_delete: "Sei sicuro di voler eliminare il modello di condivisione \"{name}\"? Questa operazione non può essere annullata.",
        smtp_remove: "Vuoi davvero rimuovere la configurazione SMTP dal tuo progetto? Il tuo dominio di invio tornerà alla configurazione standard.",
        smtp_setup: "Invia email dal tuo server di posta. Inserisci le tue credenziali SMTP . Se il tuo server utilizza restrizioni IP, aggiungi alla whitelist i seguenti IP utilizzati dal nostro sistema: {ips}.",
        space_delete: "Vuoi davvero eliminare lo spazio: {name}? Tutti i progetti al suo interno verranno eliminati.",
        tag_rule: "Aggiungi un termine positivo e la sua controparte negativa. Se applicabile, useremo l'intelligenza artificiale per contrassegnare automaticamente la recensione con uno o l'altro.",
        user_delete: "Sei sicuro di voler eliminare l'account utente per: {email}?",
        user_verify: "Per verificare il tuo indirizzo email e attivare il tuo account, clicca sul link nell'email inviata a: {email}.",
        widget_delete: "Vuoi davvero eliminare il widget: {name}? Il widget non verrà più visualizzato su nessun sito web.",
        widget_restore: "Vuoi davvero ripristinare le impostazioni per il widget: {name}? Solo il design tornerà ai valori predefiniti.",
        widgets_1: "Aggiungi questo script al corpo del tuo sito web.",
        widgets_2: "Il Muro di recensioni mostra tutte le tue recensioni in una griglia. Aggiungi questo script dove vuoi che venga visualizzato il widget.",
        widgets_3: "La Recensione in evidenza mostra una singola recensione in grande. Aggiungi questo script dove vuoi che venga visualizzato il widget."
    },
    billing_statuses: {
        active: "Il tuo abbonamento è attivo.",
        canceled: "Il tuo abbonamento è stato annullato. Aggiorna per continuare.",
        ending: "Il tuo abbonamento termina il {date}.",
        trial: "La tua prova gratuita termina il {date}.",
        trial_expired: "La tua prova gratuita è terminata. Effettua l'upgrade per continuare.",
        trial_expiring: "La tua prova gratuita sta per scadere. Effettua l'upgrade per continuare."
    },
    brands: {
        boost_space: "Boost.space",
        discord: "Discord",
        email: "E-mail",
        facebook: "Facebook",
        google: "Google",
        google_analytics: "Google Analytics",
        hubspot: "HubSpot",
        linkedin: "LinkedIn",
        make_com: "Make.com",
        messenger: "Messaggero",
        pabbly: "Pabbly",
        recaptcha: "reCAPTCHA",
        reddit: "Reddit",
        slack: "Slack",
        stripe: "Stripe",
        threads: "Threads",
        twilio: "Twilio",
        whatsapp: "WhatsApp",
        x: "X",
        zapier: "Zapier"
    },
    captions: {
        add_sending_domain: "Aggiungi un dominio di invio per modificare il tuo indirizzo email:",
        agency_robots: "Consenti ai motori di ricerca di indicizzare il tuo portale clienti.",
        analytics_average_review: "Valutazione media in stelle in questo periodo.",
        analytics_customers: "Clienti aggiunti e clienti a cui è stata chiesta una recensione per la prima volta.",
        analytics_limits: "Richieste di recensione di oggi e di questo mese.",
        analytics_location_leaderboard: "Numero di recensioni, valutazione media e percentuale di 5 stelle per sede.",
        analytics_needs_attention: "Recensioni a 1 e 2 stelle degli ultimi 3 mesi senza risposta.",
        analytics_outreach: "Messaggi inviati, cliccati e non riusciti nel tempo.",
        analytics_reply_coverage: "Percentuale di recensioni con una risposta.",
        analytics_review_velocity: "Media di recensioni ricevute a settimana.",
        analytics_review_volume: "Quante recensioni hai ricevuto in questo periodo.",
        analytics_sentiment: "Recensioni scritte classificate come positive, neutre o negative.",
        analytics_source_mix: "Numero di recensioni e valutazione media per fonte.",
        analytics_star_mix: "Numero di recensioni nel tempo per valutazione in stelle.",
        analytics_tags: "Tag più usati in questo periodo, con conteggio e media.",
        ai_business_description: "Una descrizione dettagliata della tua attività per aiutarti a generare suggerimenti e risposte alle recensioni.",
        ai_business_name: "Il nome della tua attività.",
        ai_highlights: "Evidenzia le frasi migliori delle tue recensioni positive.",
        ai_highlights_instructions: "Indica all’IA quali frasi privilegiare negli evidenziati.",
        ai_replies: "Bozza e, se vuoi, automatizza le risposte alle recensioni.",
        ai_reply_contact: "Incluso nelle risposte alle recensioni negative.",
        ai_reply_instructions: "Indica all’IA come devono suonare le risposte e cosa includere.",
        ai_review_instructions: "Indica all’IA cosa menzionare o evitare nei suggerimenti di recensione.",
        ai_review_suggestions: "Aiuta i clienti a scrivere recensioni con suggerimenti pronti all’uso.",
        ai_tags: "Applica automaticamente i tag alle recensioni che corrispondono alle istruzioni.",
        ask_location: "Posizione da assegnare alla recensione.",
        ask_review_page: "La pagina per acquisire la recensione.",
        assign_tags: "Assegna etichette alla recensione.",
        csv_max_rows: "Fino a {count} Righe",
        dashboard_configure_settings: "Configura le impostazioni del tuo progetto.",
        dashboard_import_customers: "Importa i tuoi clienti.",
        dashboard_preview_email_templates: "Visualizza in anteprima i tuoi modelli di posta elettronica.",
        dashboard_preview_kiosk_page: "Visualizza l'anteprima della pagina del chiosco.",
        dashboard_preview_review_page: "Visualizza l'anteprima della pagina di recensione.",
        dashboard_preview_showcase_page: "Visualizza l'anteprima della tua pagina vetrina.",
        detect_from_website: "Lascia vuoto per rilevare automaticamente dal sito web.",
        logo_height: "L'altezza del logo nelle e-mail e nelle pagine.",
        meta_description: "Sostituisce la descrizione della pagina.",
        meta_title: "Sostituisci il titolo della pagina.",
        mfa_password: "Inserisci la password del tuo account.",
        mfa_qr_code: "Scansiona il codice QR con la tua app di autenticazione.",
        mfa_security_code: "Inserisci il codice dalla tua app di autenticazione.",
        mcp_server_url: "Incolla questo URL in Claude, ChatGPT o qualsiasi client MCP.",
        other_website_url: "Requisiti:<br>Valutazione: da 1 a 5 stelle<br>Data: negli ultimi 2 anni<br>solo pagine pubbliche",
        override_ambassador: "Visualizza un badge nelle email, nelle pagine e nei widget dei tuoi clienti.",
        project_name: "Il nome della tua attività, del tuo marchio o del tuo sito web.",
        project_robots: "Consenti ai motori di ricerca di indicizzare le tue pagine di recensioni e di metterle in mostra.",
        project_slug: "Utilizzato nelle e-mail e nei link rivolti ai clienti se non è configurato un CNAME .",
        review_page_copied_message: "Mostrato dopo l'invio di una recensione positiva.",
        review_page_email_address: "Ricevi le recensioni a questa email.",
        review_page_link_reveal_position: "Dove rivelare i link.",
        review_page_link_revealer_label: "L'etichetta per rivelare i collegamenti.",
        review_page_link_revealer_rating: "Mostra i link se il cliente seleziona questa valutazione o una superiore, altrimenti mostra un pulsante per mostrarli.",
        review_page_native_reviews: "Consenti le recensioni su questa piattaforma.",
        review_page_rating_selection: "Salva la valutazione prima di inviare una recensione.",
        review_page_success_button_link: "Se vuoto, il collegamento predefinito è il sito web del progetto, altrimenti è il dominio della pagina.",
        review_page_warning: "Impedire ai clienti di lasciare recensioni pubbliche potrebbe comportare la rimozione della tua scheda aziendale.",
        review_reply_status: "Non possiamo rispondere pubblicamente a questa recensione. Puoi contattare direttamente il recensore.",
        scrape_facebook_url: "Requisiti:<br>Fino a 100 recensioni recenti<br>Solo pagine pubbliche",
        scrape_linkedin_url: "Requisiti:<br>Solo raccomandazioni<br>Solo pagine pubbliche",
        scrape_trustpilot_url: "Requisiti:<br>Valutazione: da 1 a 5 stelle<br>Solo pagine pubbliche",
        separate_with_commas: "Separare i multipli con virgole.",
        setup_basics: "Imposta quando e come chiedi recensioni ai clienti.",
        setup_business: "Dicci con quale nome i clienti ti conoscono.",
        setup_google: "Invia i clienti al tuo profilo Google , rispondi alle recensioni e importa quelle esistenti. Puoi saltare questo passaggio e farlo in seguito.",
        setup_location_limit: "La prova gratuita include 1 posizione. Puoi passare alla versione a pagamento in qualsiasi momento per sincronizzare più posizioni.",
        showcase_locations: "Limitare la vetrina a luoghi specifici.",
        showcase_review_length: "Le Recensioni devono essere composte da almeno questo numero caratteri.",
        showcase_since: "Mostra le recensioni create in questa data o prima.",
        showcase_sources: "Limita la vetrina a fonti specifiche.",
        showcase_tags: "Limita la vetrina alle recensioni con etichette specifici.",
        signature_html: "Copia e incolla la firma nella tua applicazione di posta elettronica.",
        signed_up: "Data di inizio del cliente.",
        twilio_webhook: "Impostalo come URL di callback per il tuo servizio di messaggistica.",
        widget_embed: "Facoltativo. L'ID di un elemento esistente in cui deve apparire il Widget.",
        widget_wordpress: "Installa il plugin, quindi incolla questo Shortcode dove dovrebbe apparire il Widget.",
    },
    labels: {
        accept_all: "Accetta tutto",
        access_code: "Codice di accesso",
        access_codes: "Codici di accesso",
        account: "Account",
        account_sid: "SID dell'account",
        action: "Azione",
        actions: "Azioni",
        activate: "Attivare",
        active: "Attivo",
        add: "Aggiungere",
        add_agency_project: "Aggiungi un progetto dell'agenzia",
        add_confirmation_message: "Aggiungi un messaggio di conferma.",
        add_css_rules: "Aggiungi le tue regole css.",
        add_custom_field: "Aggiungi campo personalizzato",
        add_customer: "Aggiungi un cliente",
        add_customers_with: "Aggiungi clienti con {model}",
        add_external_link: "Aggiungi un Collegamento esterno",
        add_external_links: "Aggiungi Collegamenti esterni",
        add_introduction: "Aggiungi un'introduzione.",
        add_js_tags: "Aggiungi i tuoi tag JavaScript .",
        add_legal_information: "Aggiungere informazioni legali.",
        add_location: "Aggiungi una posizione",
        add_project: "Aggiungi un progetto",
        add_review: "Aggiungi una Recensione",
        add_source: "Aggiungi una fonte",
        add_tag: "Aggiungi un'etichetta",
        added: "Aggiunto",
        address: "Indirizzo",
        advanced_review_pages: "Pagine di Recensione avanzate",
        affiliates: "Affiliati",
        age_of_reviews: "Età delle Recensioni",
        agencies: "Agenzie",
        agency: "Agenzia",
        agency_name: "Nome dell'agenzia",
        agency_project: "Progetto dell'Agenzia",
        agency_projects: "Progetti dell'Agenzia",
        ai: "intelligenza artificiale",
        ai_answers: "Risposte IA",
        ai_assistant: "Assistente AI",
        ai_auto_tagging: "Tagging IA",
        ai_highlights_instructions: "Esempio: Privilegia le frasi sul servizio o sul nostro brand.",
        ai_reply_instructions: "Esempio: Tieni le risposte brevi. Invita a contattarci se la recensione è negativa.",
        ai_review_instructions: "Esempio: Menziona lo staff e la visita. Non menzionare i prezzi.",
        ai_review_suggestions: "Suggerimenti recensione IA",
        ai_reviews_and_replies: "Suggerimenti e risposte di Recensione dell'IA",
        ai_tagging_instructions: "Esempio: applicare alle recensioni che menzionano tempi di attesa, servizio lento o ritardi.",
        ai_tags: "Tag IA",
        ai_tools: "Strumenti IA",
        all: "Tutto",
        allowed_domains: "Domini consentiti",
        amount: "Quantità",
        analytics: "Analisi",
        and: "E",
        anonymous_reviews: "Recensioni anonime",
        answer: "Risposta",
        any: "Qualunque",
        api: "API",
        api_key: "Chiave API",
        appearance: "Aspetto",
        apply: "Applica",
        approved: "Approvato",
        archive: "Archivio",
        archive_customer: "Archivia cliente",
        archived: "Archiviato",
        at_least: "almeno",
        at_least_days: "Almeno {num} giorni",
        at_least_hours: "Almeno {num} ore",
        at_least_months: "Almeno {num} mesi",
        at_most: "al massimo",
        at_most_days: "Al massimo {num} giorni",
        at_most_hours: "Al massimo {num} ore",
        at_most_months: "Al massimo {num} mesi",
        auth_token: "Token di autenticazione",
        authorize: "Autorizzare",
        auto_detect: "Auto",
        auto_tags: "Tag IA",
        automate: "Automatizzare",
        automate_highlights: "Automatizza evidenziazioni",
        automate_replies: "Risposte automatiche",
        automatic_review_collection: "Raccolta automatica Recensione",
        automatically_apply_tags: "Applica automaticamente l'etichetta alle recensioni esistenti",
        automating: "Automazione",
        avatar: "L'Avatar",
        avatars: "Avatar",
        average_charge: "Addebito medio",
        average_review: "Recensione media",
        background_color: "Colore di sfondo",
        background_image: "Immagine di sfondo",
        back: "Indietro",
        bcc: "BCC",
        bcc_email_address: "Indirizzo e-mail BCC",
        best_to_worst: "Dal migliore al peggiore",
        billing: "Fatturazione",
        blog: "The Reviews Guy",
        body: "Contenuto",
        body_font_size: "Dimensione del carattere Contenuto",
        bold: "Grassetto",
        book_a_demo: "Prenota una demo",
        bottom: "In basso",
        bottom_left: "In basso a sinistra",
        bottom_right: "In basso a destra",
        build_on: "Costruisci su {model}",
        business: "Business",
        business_description: "Descrizione aziendale",
        business_email: "Indirizzo email di supporto",
        business_name: "Nome dell'azienda",
        business_phone: "Numero di telefono dell'assistenza",
        business_website: "Sito Web aziendale",
        button: "Pulsante",
        button_label: "Etichetta per Pulsante",
        button_link: "Collegamento per il Pulsante",
        button_position: "Posizione del Pulsante",
        button_size: "Dimensione del Pulsante",
        buy_me_a_coffee: "Offrimi un caffè",
        by: "di",
        by_signing_up: "Creando un account, accetti i nostri",
        call_to_action: "Chiamata all'azione",
        cancel: "Cancellare",
        cancel_1_message: "Annulla 1 messaggio",
        cancel_message: "Annulla messaggio",
        cancel_messages: "Annulla i messaggi {count}",
        cancel_subscription: "Annulla abbonamento",
        cancel_unsent_messages: "Annulla i messaggi non inviati",
        canceled: "Annullato",
        center: "Centro",
        change: "Modifica",
        change_key: "Cambia la tua chiave API",
        change_plan: "Cambia piano",
        changelog: "Registro delle modifiche",
        channel: "Canale",
        channels: "Canali",
        characters: "Caratteri",
        charges_avg: "L'addebito medio deve essere almeno",
        charges_count: "Il numero di addebiti deve essere almeno",
        charges_sum: "Le spese totali devono essere almeno",
        chat_with_us: "Chatta con noi",
        checkbox: "Casella di controllo",
        claude: "Claude",
        clear: "Chiaro",
        clear_highlights_from_reviews: "Rimuovi le evidenziazioni da tutte le recensioni",
        clicked: "Cliccato",
        client: "Client",
        client_id: "ID Client",
        clients: "Clienti",
        close: "Vicino",
        cloudflare_warning: "Se utilizzi Cloudflare, il tuo proxy deve essere disattivato.",
        cname: "CNAME",
        cname_setup_incomplete: "Configurazione incompleta - verrà rimossa su {date}",
        cname_ssl_pending: "In attesa del certificato SSL",
        cname_status_for: "Stato CNAME per",
        code_editor: "Editor di codice",
        collapse: "Comprimi",
        collect_reviews_anywhere: "Raccogli recensioni ovunque",
        color: "Colore",
        colors: "Colori",
        commission_rate: "Tasso di commissione",
        commission_status_approved: "Approvato",
        commission_status_paid: "Pagato",
        commission_status_pending: "In attesa di",
        commission_status_reversed: "Invertito",
        community: "Comunità",
        company: "Azienda",
        complained: "lamentato",
        confirm_new_password: "Conferma nuova password",
        confirmation_message: "Messaggio di conferma",
        configure: "Configura",
        connect: "Collegare",
        connect_bank: "Collega il tuo conto bancario",
        connect_google: "Collega Google",
        connect_google_business_profile: "Connect Google Business Profile",
        connected: "Collegato",
        consent_preferences: "Preferenze di consenso",
        contact_customer: "Contatta il cliente",
        contact_form: "Modulo di contatto",
        contact_support: "Contattare l'assistenza.",
        contact_us: "Contattaci",
        container_element: "Elemento contenitore",
        context: "Contesto",
        continue: "Continuare",
        continue_with_google: "Continua con Google",
        cookie_category_analytics: "Analisi",
        cookie_category_essential: "Essenziale",
        cookie_category_functional: "Funzionale",
        cookie_category_marketing: "Marketing",
        cookie_consent_banner: "Banner di consenso ai cookie",
        cookie_consent_scope_all: "Mostralo a tutti",
        cookie_consent_scope_eea: "Mostra solo ai visitatori SEE e Regno Unito.",
        cookie_consent_scope_none: "Non mostrare",
        cookie_policy: "Politica sui cookie",
        cookie_preference: "Preferenza Cookie",
        copied: "Copiato",
        copied_message: "Messaggio copiato",
        copy: "Copia",
        copy_embed_code: "Copia il codice incorporato",
        copy_signature: "Copia firma email",
        copy_source_code: "Copia il codice sorgente",
        copy_to_all_ratings: "Copia in tutte le valutazioni",
        copy_uuid: "Copia UUID",
        create: "Creare",
        create_account: "Creare un account",
        create_agency: "Crea un'agenzia",
        create_cname: "Crea un record CNAME e puntalo a",
        create_external_link: "Crea un Collegamento esterno",
        create_field: "Crea un campo",
        create_link: "Crea un Collegamento",
        create_location: "Crea una posizione",
        create_project: "Crea un progetto",
        create_qr_code: "Crea un codice QR",
        create_review: "Crea una Recensione",
        create_review_page: "Crea una Pagina di Recensione",
        create_signature: "Crea una firma",
        create_source: "Crea una fonte",
        create_space: "Crea uno spazio di lavoro",
        create_tag: "Crea un'etichetta",
        create_tag_rule: "Crea una regola Etichetta",
        create_webhook: "Crea un webhook",
        create_widget: "Crea un widget",
        created_with_ai_based_on_recent_reviews: "Creato con l’IA, in base alle recensioni recenti",
        crms: "CRMs",
        csv: "CSV",
        currency: "Valuta",
        current_plan: "Piano attuale",
        current_year: "Anno corrente",
        custom_field: "Campo personalizzato",
        custom_instructions: "Istruzioni personalizzate",
        custom_url: "URL personalizzato",
        customer: "Cliente",
        customer_name_convention: "Convenzione sui nomi dei clienti",
        customer_reviews: "Recensioni dei clienti",
        customers: "Clienti",
        customize: "Personalizzare",
        customize_review_page: "Personalizza la Pagina di Recensione",
        daily: "Quotidiano",
        daily_email_requests: "Richieste giornaliere via e-mail",
        daily_limit: "Limite giornaliero",
        daily_requests: "Richieste giornaliere",
        daily_sms_requests: "Richieste SMS giornaliere",
        dark: "Buio",
        dashboard: "Cruscotto",
        date: "Data",
        date_added: "Data aggiunta",
        date_canceled: "Data di annullamento",
        date_clicked: "Data di clic",
        date_complained: "Data del reclamo",
        date_delivered: "Data di consegna",
        date_failed: "Data non riuscita",
        date_messaged: "Data messaggio",
        date_opened: "Data di apertura",
        date_replied: "Data di risposta",
        date_requested: "Data richiesta",
        date_reviewed: "Data Recensito",
        date_scheduled: "Data programmata",
        date_sent: "Data di invio",
        date_signed_up: "Data di iscrizione",
        date_updated: "Data di aggiornamento",
        dates: "Date",
        day: "Giorno",
        days: "Giorni",
        days_after_last_request: "giorni dopo l'ultima richiesta",
        days_later: "giorni dopo",
        deactivate: "Disattivare",
        default: "Predefinito",
        default_language: "Lingua predefinita",
        default_review_page: "Pagina di Recensione predefinita",
        default_review_visibility: "Visibilità Recensione predefinita",
        default_tone: "Tono predefinito",
        delay: "Ritardo",
        delete: "Eliminare",
        delete_1_customer: "Elimina 1 cliente",
        delete_1_review: "Elimina 1 Recensione",
        delete_1_review_page: "Elimina 1 Pagina di recensione",
        delete_1_widget: "Elimina 1 widget",
        delete_agency: "Elimina agenzia",
        delete_custom_field: "Elimina campo personalizzato",
        delete_customer: "Elimina cliente",
        delete_customers: "Elimina clienti",
        delete_external_link: "Elimina Collegamento esterno",
        delete_field: "Elimina campo",
        delete_link: "Elimina Collegamento",
        delete_location: "Elimina posizione",
        delete_message: "Elimina messaggio",
        delete_n_customers: "Elimina i clienti {count}",
        delete_n_review_pages: "Elimina le Pagine di recensione {count}",
        delete_n_reviews: "Elimina le Recensioni {count}",
        delete_n_widgets: "Elimina i widget {count}",
        delete_project: "Elimina progetto",
        delete_qr_code: "Elimina il codice QR",
        delete_reply: "Elimina risposta",
        delete_review: "Elimina Recensione",
        delete_review_page: "Elimina Pagina di Recensione",
        delete_review_pages: "Elimina le Pagine di Recensione",
        delete_reviews: "Elimina Recensioni",
        delete_signature: "Elimina firma email",
        delete_source: "Elimina origine",
        delete_space: "Elimina Spazio",
        delete_tag: "Elimina Etichetta",
        delete_tag_rule: "Elimina regola Etichetta",
        delete_template: "Elimina modello",
        delete_user: "Elimina utente",
        delete_webhook: "Elimina Webhook",
        delete_widget: "Elimina widget",
        delete_widgets: "Elimina widget",
        deleted: "Eliminato",
        delivered: "Consegnato",
        description: "Descrizione",
        deselect_all: "Deseleziona tutto",
        disable: "Disabilitare",
        disable_automatic_review_collection: "Disabilita la raccolta automatica Recensione",
        disable_field: "Disabilita campo",
        disable_when_links_are_visible: "Disattiva quando i link sono visibili",
        disabled: "Disabilitato",
        disconnect: "Disconnettersi",
        disconnect_integration: "Disconnetti l'integrazione",
        discord_community: "Comunità Discord",
        display_name: "Nome da visualizzare",
        dmarc: "DMARC",
        dmarc_status_for: "Stato DMARC per",
        do_not_hide_from_public: "Non nasconderti dal pubblico",
        do_not_send: "Non inviare",
        docs: "Documenti",
        documentation: "Documentazione",
        domain: "Dominio",
        domain_name: "Nome di dominio",
        dont_have_an_account: "Non hai un account?",
        dont_send_thanks: "Non inviare ringraziamenti",
        done: "Fatto",
        download: "Scaricamento",
        download_plugin: "Scarica il plugin",
        download_records: "Scarica i record",
        download_template: "Scarica il modello",
        dpa: "DPA",
        dsar: "DSAR",
        dropdown: "Menu a tendina",
        duplicate: "Duplicato",
        duplicate_project: "Progetto duplicato",
        duplicate_review_page: "Pagina di Recensione duplicata",
        duplicate_reviews: "Recensioni duplicate",
        duplicate_widget: "Widget duplicato",
        edit: "Modificare",
        edit_1_customer: "Modifica 1 cliente",
        edit_1_review: "Modifica 1 Recensione",
        edit_client: "Modifica Client",
        edit_custom_field: "Modifica campo personalizzato",
        edit_customer: "Modifica cliente",
        edit_customers: "Modifica clienti",
        edit_field: "Modifica campo",
        edit_link: "Modifica Collegamento",
        edit_location: "Modifica posizione",
        edit_member: "Modifica membro",
        edit_n_customers: "Modifica {count} Clienti",
        edit_n_reviews: "Modifica {count} Recensioni",
        edit_notes: "Modifica note",
        edit_qr_code: "Modifica codice QR",
        edit_reviews: "Modifica Recensioni",
        edit_signature: "Modifica firma email",
        edit_source: "Modifica origine",
        edit_strategy: "Modifica strategia",
        edit_tag: "Modifica Etichetta",
        edit_tag_rule: "Modifica regola Etichetta",
        edit_tags: "Modifica tag",
        edit_team_member: "Membro del team di modifica",
        edit_visibility: "Modifica visibilità",
        edit_webhook: "Modifica Webhook",
        editable_ratings: "Valutazioni modificabili",
        earned: "Guadagnato",
        eligible: "Idoneo",
        email: "E-mail",
        email_address: "Indirizzo e-mail",
        email_validation_invalid: "Convalida e-mail non riuscita",
        email_validation_passed: "Convalida e-mail superata",
        email_validation_unknown: "L'email non è stata verificata",
        emails: "E-mail",
        embed_code: "Codice incorporato",
        enable: "Abilitare",
        enable_automatic_review_collection: "Abilita la raccolta automatica Recensione",
        enable_for_all_reviews: "Abilita per tutte le recensioni",
        enable_for_positive_reviews: "Abilita per recensioni positive",
        enable_on_review_pages: "Abilita nelle pagine di Recensione",
        enabled: "Abilitato",
        end: "Fine",
        ends: "Fine",
        exclude: "Escludere",
        exclude_email: "Escludi e-mail",
        exclude_sms: "Escludi SMS",
        excluded_channels: "Canali esclusi",
        expand: "Espandere",
        expired: "Scaduto",
        export: "Esportare",
        export_1_customer: "Esporta 1 cliente",
        export_1_review: "Esporta 1 Recensione",
        export_all: "Esporta tutto",
        export_all_customers: "Esporta tutti i clienti",
        export_all_reviews: "Esporta tutte le Recensioni",
        export_customers: "Esporta clienti",
        export_n_customers: "Esporta clienti {count}",
        export_n_reviews: "Esporta {count} Recensioni",
        export_reviews: "Esporta recensioni",
        external_link: "Collegamento esterno",
        external_links: "Collegamenti esterni",
        extra_locations: "Sedi aggiuntive",
        faces: "Volti",
        failed: "Fallito",
        feedback: "Feedback",
        feedback_form: "Modulo di feedback",
        field: "Campo",
        fields: "Campi",
        filter: "Filtro",
        first: "Primo",
        first_charged: "Primo addebito",
        first_name: "Nome di battesimo",
        first_name_last_initial: "Nome, iniziale del cognome",
        five_star_share: "5 stelle %",
        flag_as_duplicate: "Segnala come duplicato",
        font: "Font",
        font_family: "Famiglia di caratteri",
        font_size: "Dimensione del carattere",
        footer: "Piè di pagina",
        for: "Per",
        forgot_password: "Ha dimenticato la password",
        form: "Modulo",
        free: "Gratuito",
        free_requests_included: "Richieste gratuite incluse",
        from: "da",
        full_name: "Nome e cognome",
        generate: "Generare",
        generate_meta: "Genera Meta",
        generate_qr_code: "Genera codice QR",
        generate_reply: "Genera risposta",
        generate_review: "Genera Recensione",
        generating: "Generazione in corso",
        get_started: "Iniziare",
        get_started_checklist: "Lista di controllo per iniziare",
        get_the_lifetime_deal: "Ottieni l'offerta a vita",
        getting_started: "Iniziare",
        google_fonts: "Caratteri Google",
        grouped_by_request: "Raggruppati per richiesta",
        has_links: "Ha Collegamenti",
        has_notes: "Ha note",
        has_redirects: "Ha reindirizzamenti",
        have_an_account: "Hai un account?",
        header: "Intestazione",
        hidden: "Nascosto",
        hidden_from_search_engines: "Nascosto dai motori di ricerca",
        hidden_reviews: "Recensioni nascoste",
        hide: "Nascondere",
        hide_all_reviews: "Nascondi tutte le recensioni",
        hide_avatar: "Nascondi Avatar",
        hide_date: "Nascondi data",
        hide_drop_shadow: "Nascondi ombra portata",
        hide_field_label: "Nascondi etichetta campo",
        hide_from_public: "Nascondi dal pubblico",
        hide_name: "Nascondi nome",
        hide_pagination: "Nascondi paginazione",
        highlight_color: "Colore di evidenziazione",
        hipaa: "HIPAA",
        host: "Host",
        hours: "Ore",
        icon: "Icona",
        icon_size: "Dimensione dell'icona",
        icons: "Icone",
        id: "ID",
        image: "Immagine",
        import: "Importare",
        import_address1: "Riga 1 dell'indirizzo del cliente.",
        import_address2: "Riga 2 dell'indirizzo del cliente.",
        import_city: "La città o la località del cliente.",
        import_company: "Il nome dell’azienda del cliente.",
        import_created_at: "La data della Recensione.",
        import_customers: "Importare clienti",
        import_email: "L’indirizzo email del cliente.",
        import_first_name: "Il nome del cliente.",
        import_from_boost_space: "Importa da Boost.space",
        import_from_hubspot: "Importa da HubSpot",
        import_from_make_com: "Importa da Make.com",
        import_from_pabbly: "Importazione da Pabbly",
        import_from_stripe: "Importa da Stripe",
        import_from_zapier: "Importa da Zapier",
        import_last_name: "Il cognome del cliente.",
        import_list: "Elenco separato da virgole di",
        import_notes: "Note solo per uso interno.",
        import_phone: "Il numero di telefono del cliente.",
        import_postal_code: "Il codice postale del cliente.",
        import_recent_reviews: "Importa Recensioni recenti",
        import_review: "Il testo della recensione.",
        import_reviews: "Importa Recensioni",
        import_score: "Valutazione da 1 a 5.",
        import_signed_up_at: "Data di inizio del cliente.",
        import_slug: "Lo slug o UUID di un",
        import_state: "Lo stato o la regione del cliente.",
        import_yourself: "Importa te stesso",
        incentive: "Incentivo",
        include: "Include",
        include_sample_reviews: "Includi recensioni di esempio",
        incoming_webhook_url: "URL del webhook in arrivo",
        inherit: "Ereditare",
        initializing: "Inizializzazione",
        initials: "Iniziali",
        install_in: "Installare in",
        insert_variable: "Inserisci variabile",
        instructions: "Istruzioni",
        integration: "Integrazione",
        integrations: "Integrazioni",
        interval: "Intervallo",
        introduction: "Introduzione",
        invite: "Invitare",
        invite_client: "Invita il Client",
        invite_failed: "Invito fallito",
        invite_member: "Invita un membro",
        invite_sent_to: "Invito inviato a",
        invite_team_member: "Invita un membro del team",
        invited: "Invitato",
        issuer_url: "URL dell'emittente",
        italic: "Corsivo",
        joined: "Partecipato",
        key: "Chiave",
        keywords: "Parole chiave",
        keywords_in_replies: "Parole chiave nelle risposte",
        keywords_in_reviews: "Parole chiave nelle Recensioni",
        kiosk_page: "Pagina del chiosco",
        label: "Etichetta",
        label_font_size: "Dimensione carattere etichetta",
        labels: "Etichette",
        language: "Lingua",
        languages: "Lingue",
        large: "Grande",
        last_12_months: "Ultimi 12 mesi",
        last_2_years: "Ultimi 2 anni",
        last_3_months: "Ultimi 3 mesi",
        last_4_weeks: "Ultime 4 settimane",
        last_6_months: "Ultimi 6 mesi",
        last_charged: "Ultimo addebito",
        last_name: "Cognome",
        layout: "Disposizione",
        leave: "Partire",
        leave_project: "Progetto di uscita",
        leave_space: "Lascia Spazio di lavoro",
        left: "Sinistra",
        let_clients_sign_in_with_sso: "Consenti ai clienti di accedere con SSO",
        less: "meno",
        lifecycle_stage: "Fase del ciclo di vita",
        lifetime_deal: "Offerta a vita",
        light: "Leggero",
        limit: "Limite",
        limits: "Limiti",
        link: "Collegamento",
        link_color: "Colore del link",
        link_reveal_position: "Posizione di rivelazione link",
        link_revealer_button: "Pulsante di rivelazione Collegamento",
        link_revealer_label: "Etichetta Collegamento rivelatore",
        link_revealer_rating: "Valutazione minima per rivelare i link",
        links: "Collegamenti",
        links_per_review_page: "Collegamenti per Pagina di Recensione",
        list: "Lista",
        list_unsubscribe_headers: "Intestazioni List-Unsubscribe",
        load_more: "Carica altro",
        loading: "Caricamento",
        location: "Posizione",
        location_address: "Posizione Indirizzo",
        location_name: "Nome della posizione",
        location_picker: "Selettore di posizione",
        locations: "Posizioni",
        locations_limit: "Limite di posizioni",
        log_in: "Login",
        log_out: "Esci",
        logo: "Logo",
        logo_height: "Altezza del logo",
        long: "Lungo",
        lowest_rating: "Valutazione più bassa",
        ltd: "LTD",
        make_default: "Rendi predefinito",
        manage: "Gestisci",
        manage_limits: "Gestisci limiti",
        manage_overrides: "Gestisci override",
        manage_payout_account: "Gestisci il conto pagamenti",
        manage_subscription: "Gestisci abbonamento",
        manual_entry: "Inserimento manuale",
        max: "Massimo",
        max_size: "Dimensione massima",
        maximum_characters: "Numero massimo Caratteri",
        maximum_customers: "Clienti massimi",
        maximum_locations: "Posizioni massime",
        maximum_members: "Numero massimo di membri",
        maximum_review_length: "Lunghezza massima Recensione",
        maximum_tags: "Etichette massimi",
        maximum_widgets: "Widget massimi",
        mcp: "Server MCP",
        mcp_server: "Server MCP",
        mcp_server_url: "URL Server MCP",
        medium: "Medio",
        member: "Membro",
        members: "Membri",
        menu: "Menu",
        message: "Messaggio",
        message_link_expiration: "Scadenza Collegamento al messaggio",
        messaged: "Messaggio inviato",
        messages: "Messaggi",
        messages_clicked: "Messaggi cliccati",
        messages_sent: "Messaggi inviati",
        messaging_service_sid: "SID del servizio di messaggistica",
        min: "Minimo",
        min_size: "Dimensione minima",
        minimal_delay: "Ritardo minimo",
        minimum_characters: "Caratteri minimi",
        minutes: "Minuti",
        month: "mese",
        month_to_date: "Mese in corso",
        monthly: "Mensile",
        monthly_email_requests: "Richieste mensili via email",
        monthly_limit: "Limite mensile",
        monthly_pricing_only: "Solo prezzi mensili",
        monthly_request_limit: "Limite di richiesta mensile",
        monthly_requests: "Richieste mensili",
        monthly_sms_requests: "Richieste SMS mensili",
        months: "Mesi",
        months_free: "{count} mesi gratuiti",
        more: "Di più",
        more_clients: "più clienti",
        more_customers: "più clienti",
        more_options: "Altre opzioni",
        more_patients: "più pazienti",
        more_reviews: "altre recensioni",
        more_reviews_needed: "Sono necessarie più recensioni per riassumere",
        more_users: "più utenti",
        more_visitors: "più visitatori",
        most_negative: "Più negativi",
        most_positive: "Più positivi",
        move: "Mossa",
        moved: "Mosso",
        name: "Nome",
        native_reviews: "Recensioni native",
        negative: "Negativo",
        negative_term: "Termine negativo",
        new: "Nuovo",
        new_password: "Nuova password",
        newest: "Più recenti",
        neutral: "Neutro",
        no: "No",
        no_available_options: "Nessuna opzione disponibile",
        no_credit_card_required: "Non è richiesta la carta di credito",
        no_data_available: "Nessun dato disponibile",
        no_reminders: "Non inviare promemoria",
        no_retries: "Nessun nuovo tentativo",
        no_review: "Nessuna recensione",
        none: "Nessuno",
        not_connected: "Non connesso",
        not_reviewed: "Non Recensito",
        notes: "Note",
        notifications: "Notifiche",
        now: "Ora",
        n_1_ai_tag: "1 tag IA",
        n_1_review_page: "1 pagina recensione",
        n_ai_tags: "{count} tag IA",
        n_review_pages: "{count} pagine recensione",
        number_of_charges: "Numero di addebiti",
        number_of_reminders: "Numero di promemoria",
        number_of_retries: "Numero di tentativi",
        number_of_review_suggestions: "Numero di suggerimenti Recensione",
        of: "Di",
        off: "Spento",
        on: "Su",
        on_for_positive_reviews: "Attivo per le recensioni positive",
        on_channel: "sul canale {channel}.",
        opened: "Aperto",
        options: "Opzioni",
        or_log_in_with_email: "oppure accedi con il tuo indirizzo email",
        or_sign_up_with_email: "oppure usa il tuo indirizzo email",
        other_website: "Altro sito web",
        our_reviews: "Le nostre Recensioni",
        output: "Produzione",
        page_footer: "Piè di pagina",
        paid: "Pagato",
        paragraph: "Paragrafo",
        password: "Password",
        past_month: "Mese scorso",
        past_months: "Ultimi {inc} mesi",
        past_week: "Settimana scorsa",
        past_year: "Anno scorso",
        past_years: "Ultimi {inc} anni",
        paused: "In pausa",
        payment_method: "Metodo di pagamento",
        payout_status_completed: "Completato",
        payout_status_pending: "In attesa di",
        pending: "In attesa di",
        pending_deployment: "In attesa di distribuzione",
        pending_validation: "In attesa di convalida",
        per_day: "al giorno",
        per_month: "al mese",
        period: "Periodo",
        permissions: "Autorizzazioni",
        phone: "Telefono",
        phone_number: "Numero di telefono",
        pixels: "pixel",
        placeholder: "Segnaposto",
        placement: "Posizionamento",
        plan: "Piano",
        plan_bullet1: "Rimuovi il nostro marchio da e-mail, pagine e widget",
        plan_bullet2: "Utilizza il tuo dominio per le pagine rivolte ai clienti e per l'invio di e-mail",
        plan_bullet3: "Rendi tuo il prodotto con il white labeling per le agenzie",
        please_rate_our_service: "Valuta il nostro servizio",
        png: "PNG",
        policies: "Politiche",
        positive: "Positivo",
        popular: "Popolare",
        port: "Porta",
        position: "Posizione",
        positive_only: "Solo Recensioni positive",
        positive_term: "Termine positivo",
        powered_by: "Offerto da",
        preview: "Anteprima",
        preview_kiosk_page: "Visualizza pagina chiosco",
        preview_review_page: "Visualizza pagina di recensione",
        price: "Prezzo",
        pricing: "Prezzi",
        primary_color: "Colore primario",
        priority: "Priorità",
        privacy_policy: "politica sulla riservatezza",
        proceed_to_dashboard: "Vai alla Dashboard",
        product: "Prodotto",
        profile: "Profilo",
        project: "Progetto",
        project_name: "Nome del progetto",
        setup_ask_delay: "Quanto tempo aspettare prima di chiedere una recensione?",
        setup_reminders: "Quanti promemoria inviare",
        project_paused: "Questo progetto è in pausa.",
        project_suspended: "Questo progetto è sospeso.",
        project_website: "Sito web del progetto",
        projects: "Progetti",
        projects_limit: "Limite dei progetti",
        publish: "Pubblicare",
        publish_changes: "Pubblicare le modifiche su tutte le altre pagine di Recensione",
        published: "Pubblicato",
        purchase: "Acquistare",
        qr_code: "Codice QR",
        qr_code_name_placeholder: "Tavolo 1, Reception",
        qr_codes: "Codici QR",
        quarter_to_date: "Trimestre in corso",
        quantity: "Quantità",
        query: "Domanda",
        quick_import: "Importazione rapida",
        rating: "Punteggio",
        rating_order: "Ordine di valutazione",
        rating_out_of: "valutazione su",
        rating_save_all: "Salva la valutazione prima di ogni recensione",
        rating_save_customer: "Salva la valutazione prima di una recensione del cliente",
        rating_save_never: "Non salvare mai la valutazione prima della Recensione",
        rating_selection: "Selezione della valutazione",
        rating_selector: "Selettore di valutazione",
        ratings: "Valutazioni",
        read: "Leggere",
        reapply_highlights_eligible: "Rigenera i punti salienti con l'IA per tutte le recensioni positive",
        reconnect: "Riconnettersi",
        redeem: "Riscatta",
        redirect_uri: "URI di reindirizzamento",
        redirects: "Reindirizzamenti",
        refer_and_earn: "Invita un amico e guadagna",
        referral_billing_status_active: "Iscritto",
        referral_billing_status_canceled: "Annullato",
        referral_billing_status_trial: "Prova",
        referral_billing_status_trial_expired: "Prova scaduta",
        referral_billing_status_trial_expiring: "Periodo di prova in scadenza",
        referral_program: "Termini e condizioni del programma di segnalazione",
        referral_program_terms: "Termini e condizioni del programma di segnalazione",
        referrals: "Segnalazioni",
        refresh: "Aggiornare",
        regenerate: "Rigenerare",
        reject_all: "Rifiuta tutto",
        related_reviews: "Recensioni simili",
        related_similarity: "Somiglianza",
        remaining: "Rimanente",
        reminder: "Promemoria",
        reminders: "Promemoria",
        remove: "Rimuovere",
        remove_client: "Rimuovi il Client",
        remove_cname: "Rimuovere CNAME",
        remove_domain: "Rimuovi dominio",
        remove_from_project: "Rimuovi dal progetto",
        remove_member: "Rimuovi membro",
        remove_smtp_configuration: "Rimuovere la configurazione SMTP",
        remove_team_member: "Rimuovere il membro del team",
        rename: "Rinominare",
        rename_template: "Rinomina modello",
        renews: "Rinnova",
        replied: "Risposto",
        reply: "Rispondere",
        reply_coverage: "Copertura delle risposte",
        reply_to: "Indirizzo di risposta",
        replying_on: "Rispondendo su",
        request: "Richiesta",
        request_1_review: "Richiedi 1 recensione",
        request_date: "Data di richiesta",
        request_n_reviews: "Richiedi {count} recensioni",
        request_review: "Richiedi una Recensione",
        request_reviews: "Richiedi Recensioni",
        requested: "Richiesto",
        requested_review: "Recensione richiesta",
        requests: "Richieste",
        requests_left_this_month: "richieste rimaste questo mese",
        requests_remaining: "Richieste rimanenti",
        require_field: "Campo obbligatorio",
        require_sso: "Richiede SSO",
        required: "Necessario",
        reschedule_message: "Riprogramma messaggio",
        resend_invite: "Invia nuovamente l'invito",
        reset_password: "Reimposta password",
        restore: "Ripristinare",
        restore_to_defaults: "Ripristina impostazioni predefinite",
        restore_widget: "Ripristina widget",
        resubscribe: "Ri-iscriviti",
        resubscribe_customer: "Riabbona il cliente",
        resync: "Ri-sincronizzazione",
        resync_account: "Risincronizza account",
        resync_now: "Risincronizza ora",
        retries: "Nuovi tentativi",
        reveal_above_form: "Mostra sopra il modulo",
        reveal_after_submission: "Rivela dopo l'invio",
        reveal_below_form: "Rivela sotto il modulo",
        review: "Recensione",
        review_length: "Lunghezza Recensione",
        review_link: "Collegamento Recensione",
        review_missed: "Recensione persa",
        review_not_requested: "Recensione non richiesta",
        review_origin: "Questa recensione è stata originata dal modello",
        review_page: "Pagina di recensione",
        review_pages: "Pagine di recensione",
        review_requested: "Recensione richiesta",
        review_spotlight: "Recensione in evidenza",
        review_suggestion: "Suggerimento Recensione",
        review_suggestions: "Suggerimenti Recensione",
        review_summary: "Riepilogo recensioni",
        review_text: "Testo Recensione",
        review_velocity: "Recensioni a settimana",
        review_volume: "Volume recensioni",
        review_wall: "Muro di recensioni",
        reviewed: "Recensito",
        reviews: "Recensioni",
        reviews_ask: "Chiedere",
        reviews_query_failed: "Si è verificato un errore. Riprova.",
        reviews_query_placeholder: "Cerca recensioni o fai una domanda...",
        reviews_with_highlights: "Recensioni con punti salienti",
        reviews_with_replies: "Recensioni con risposte",
        reviews_without_replies: "Recensioni senza risposte",
        revoke: "Revocare",
        revoke_client: "Revoca l'app",
        roadmap: "Tabella di marcia",
        role: "Ruolo",
        sans_serif: "Senza grazie",
        save: "Salvare",
        save_preferences: "Salvare preferenze",
        save_template: "Salvare modello",
        save_template_as_new: "Salvare nuovo modello",
        saved: "Salvato",
        schedule: "Programma",
        schedule_review_request: "Richiesta di recensione",
        scheduled: "Programmato",
        score: "Punto",
        search: "Ricerca",
        second: "Secondo",
        secret_key: "Chiave segreta",
        sections: "Sezioni",
        security_code: "Codice di sicurezza",
        select: "Selezionare",
        select_account: "Seleziona un account",
        select_all: "Seleziona tutto",
        select_an_option: "Seleziona un'opzione",
        select_bulk_action: "Seleziona Azione in blocco",
        select_csv_file: "Seleziona file CSV",
        select_date: "Seleziona la data",
        select_field: "Seleziona un campo",
        select_icon: "Seleziona un'icona",
        select_location: "Seleziona una posizione",
        select_plan: "Seleziona un piano",
        select_review: "Seleziona una Recensione",
        select_source: "Seleziona una fonte",
        select_tag: "Seleziona un'etichetta",
        selected: "Selezionato",
        send: "Inviare",
        send_1_reminder: "Invia 1 promemoria",
        send_2_reminders: "Invia 2 promemoria",
        send_3_reminders: "Invia 3 promemoria",
        send_anytime: "Invia in qualsiasi momento",
        send_between: "Invia tra",
        send_message: "Invia messaggio",
        send_retries: "Invia {count} Tentativi",
        send_retry: "Invia {count} Riprova",
        send_test: "Invia un test",
        send_thanks: "Inviare ringraziamenti",
        sender_email_address: "Indirizzo e-mail del mittente",
        sender_id: "ID mittente",
        sender_name: "Nome del mittente",
        sending_domain: "Dominio di invio",
        sentiment: "Sentiment",
        sent: "Inviato",
        sent_replies: "Risposte inviate",
        serif: "Serif",
        set_up: "Configura",
        settings: "Impostazioni",
        share: "Condividere",
        share_link: "Condividi Collegamento",
        short: "Corto",
        shortcode: "Shortcode",
        show: "Mostra",
        show_1_suggestion: "Mostra 1 suggerimento",
        show_100_results: "Mostra 100 risultati",
        show_2_suggestions: "Mostra 2 suggerimenti",
        show_25_results: "Mostra 25 risultati",
        show_3_suggestions: "Mostra 3 suggerimenti",
        show_4_suggestions: "Mostra 4 suggerimenti",
        show_5_suggestions: "Mostra 5 suggerimenti",
        show_50_results: "Mostra 50 risultati",
        show_all_reviews: "Mostra tutte le recensioni",
        show_arrows: "Mostra frecce",
        show_avatar: "Mostra Avatar",
        show_cookie_consent_banner: "Mostra il banner di consenso ai cookie",
        show_date: "Mostra data",
        show_dots: "Mostra punti",
        show_drop_shadow: "Mostra ombra portata",
        show_field: "Mostra campo sulle seguenti valutazioni",
        show_full: "Mostra stelle complete",
        show_photo: "Mostra solo foto",
        show_positive_reviews: "Mostra solo recensioni positive",
        show_to_public: "Mostra al pubblico",
        showcase: "Showcase",
        showcase_page: "Pagina vetrina",
        sign_up: "Iscrizione",
        sign_up_for_free: "Iscriviti gratuitamente",
        sign_up_with_email: "Registrati con e-mail",
        sign_in_with_sso: "Accedi con SSO",
        sign_up_with_google: "Registrati con Google",
        signature: "Firma email",
        signatures: "Firme email",
        signed_up: "Registrato",
        since: "Da",
        size: "Misurare",
        skip: "Saltare",
        skipped_required_fields: "Campi obbligatori ignorati: {fields}",
        slug: "Slug",
        small: "Piccolo",
        sms: "SMS",
        smtp_configuration: "Configurazione SMTP",
        sort: "Ordinare",
        source: "Fonte",
        source_code: "Codice sorgente",
        sources: "Fonti",
        space: "Spazio di lavoro",
        space_name: "Nome Spazio",
        spaces: "Spazi di lavoro",
        split: "Diviso",
        sso: "SSO",
        star: "Stella",
        star_color: "Colore stella",
        stars: "Stelle",
        start: "Inizio",
        start_free_trial: "Inizia la prova gratuita",
        start_getting_more_reviews: "Inizia a ricevere più Recensioni",
        start_over: "Riavvia",
        status: "Stato",
        store_code: "Codice negozio",
        strategy: "Strategia",
        sub_processors: "Sottoprocessori",
        subject: "Soggetto",
        subscribe: "Iscriviti",
        subscription: "Sottoscrizione",
        success_page: "Pagina di successo",
        suggestion: "Suggerimento",
        suggestions: "Suggerimenti",
        summary: "Riepilogo",
        support: "Assistenza",
        suspend: "Sospendere",
        suspend_project: "Sospendi progetto",
        suspended: "Sospeso",
        svg: "SVG",
        switch_to_smtp_setup: "Passa alla configurazione SMTP",
        switch_to_standard_setup: "Passa alla configurazione standard",
        symbol: "Simbolo",
        sync: "Sincronizzazione",
        sync_account: "Sincronizza account",
        sync_now: "Sincronizza ora",
        sync_scheduled_time: "Sincronizzazione programmata {time}",
        sync_with_facebook: "Sincronizza con Facebook",
        sync_with_google: "Sincronizza con Google",
        synced_time: "Sincronizzato {time}",
        system: "Sistema",
        system_fonts: "Caratteri di sistema",
        tag: "Etichetta",
        tag_1_customer: "Etichetta 1 Cliente",
        tag_1_review: "Etichetta 1 recensione",
        tag_customers: "Etichetta clienti",
        tag_existing_reviews: "Etichetta le Recensioni esistenti",
        tag_n_customers: "Etichetta {count} Clienti",
        tag_n_reviews: "Etichetta {count} Recensioni",
        tag_reviews: "Etichetta recensioni",
        tag_rule: "Regola dei tag",
        tag_with_ai: "Etichetta con AI",
        tags: "Etichette",
        tags_for_customers: "Etichette per i clienti",
        tags_for_reviews: "Etichette per Recensioni",
        team: "Squadra",
        team_member: "Membro del team",
        team_members: "Membri del team",
        template: "Modello",
        templates: "Modelli",
        terms_of_service: "Termini di servizio",
        test_template: "Modello di prova",
        tests: "Test",
        text: "Testo",
        text_alignment: "Allineamento del testo",
        text_color: "Colore del testo",
        thank_you_messages: "Messaggi di ringraziamento",
        thanks: "Grazie",
        theme: "Tema",
        third: "Terzo",
        time_zone: "Fuso orario",
        timeframe: "Lasso di tempo",
        title: "Titolo",
        tone: "Tono",
        top: "Superiore",
        top_left: "In alto a sinistra",
        top_right: "In alto a destra",
        total_charges: "Totale spese",
        total_reviews: "Recensioni totali",
        trend_mentions: "{count} menzioni, {percent}%",
        trigger: "Trigger",
        trigger_charged: "Invia richiesta dopo un addebito",
        trigger_created: "Invia richiesta dopo la registrazione",
        try_free: "Prova gratis",
        try_it_free: "Provalo gratis",
        type: "Tipo",
        types: "Tipi",
        unarchive: "Disarchiviare",
        unarchive_customer: "Ripristina cliente dall'archivio",
        underline: "Sottolineare",
        unflag_as_duplicate: "Rimuovi contrassegno come duplicato",
        unknown: "Sconosciuto",
        unlimited: "illimitato",
        unnamed: "Senza nome",
        unpublish: "Annulla pubblicazione",
        unpublished: "Non pubblicato",
        unreplied: "Senza risposta",
        unsent_messages: "Messaggi non inviati",
        unsubscribe: "Annulla iscrizione",
        unsubscribe_1_customer: "Annulla iscrizione di 1 cliente",
        unsubscribe_customer: "Annulla iscrizione cliente",
        unsubscribe_customers: "Annulla iscrizione clienti",
        unsubscribe_n_customers: "Annulla iscrizione di {count} clienti",
        unsubscribe_text: "Testo di annullamento dell'iscrizione",
        unsubscribed: "Annulla iscrizione",
        unsuspend: "Riattiva",
        unsuspend_project: "Riattiva il progetto",
        unverified: "Non verificato",
        update: "Aggiornamento",
        update_password: "Aggiorna password",
        update_plan: "Aggiorna il piano",
        update_share_template: "Modello di aggiornamento",
        updated: "Aggiornato",
        updates: "Aggiornamenti",
        upgrade: "Aggiornamento",
        upgrade_for_more: "Aggiorna per di più",
        upgrade_to_use: "Effettua l'aggiornamento per utilizzare questa funzionalità",
        upload: "Caricamento",
        upload_csv: "Carica CSV",
        upload_icon: "Carica un'icona",
        url: "URL",
        use: "Utilizzo",
        use_filters_for_aggregate: "Utilizzare i filtri per l'aggregazione",
        user: "Utente",
        user_id: "ID utente",
        user_info: "Informazioni utente",
        username: "Nome utente",
        utc: "UTC",
        validate: "Convalidare",
        validate_customer_email: "Convalida l'email del cliente",
        validation: "Validazione",
        validations: "Validazioni",
        value: "Valore",
        verify: "Verificare",
        verify_email_address: "Verifica l'indirizzo email",
        view: "Visualizza",
        view_all: "Visualizza tutto",
        view_all_features: "Visualizza tutte le funzionalità",
        view_available_fields: "Visualizza i campi disponibili",
        view_documentation: "Visualizza la documentazione",
        view_email_templates: "Visualizza modelli di posta elettronica",
        view_review_pages: "Visualizza le Pagine di Recensione",
        view_reviews: "Visualizza Recensioni",
        vs_prior: "vs periodo precedente",
        view_settings: "Visualizza impostazioni",
        view_setup_guide: "Visualizza la guida all'installazione",
        view_showcase: "Visualizza la vetrina",
        view_strategy: "Visualizza strategia",
        visibility: "Visibilità",
        visible: "Visibile",
        visible_reviews: "Recensioni visibili",
        visible_to_search_engines: "Visibile ai motori di ricerca",
        wait_between_reminders: "Attendi tra i promemoria",
        wait_period: "Periodo di attesa",
        webhook: "Webhook",
        webhooks: "Webhook",
        website: "Sito web",
        weekly: "Settimanale",
        weeks: "Settimane",
        widget: "Widget",
        widgets: "I widget",
        with_ai: "con l'intelligenza artificiale",
        wordpress: "WordPress",
        worst_to_best: "Dal peggiore al migliore",
        would_redirect_to: "Reindirizzerebbe a {url}",
        write: "Scrivere",
        written_reviews: "Recensioni scritte",
        year: "anno",
        year_to_date: "Anno in corso",
        yearly: "Annuale",
        yes: "Sì",
        you: "Voi",
        your_referral_link: "Il tuo Collegamento di invito"
    },
    landing: {
        announcement: "Ottieni report di reputazione con il nostro server MCP",
        counter: "Unisciti a oltre 5.000 attività locali di servizi",
        counter_agencies: "Usato da oltre 500 agenzie per la gestione delle recensioni",
        counter_ai: "Gestisci la reputazione da Claude e ChatGPT",
        ai_screen_1_badge: "MCP",
        ai_screen_1_bullets: [
            "Ottieni risposte senza dover accedere a un'altra dashboard.",
            "Agisci sulla reputazione negli strumenti di chat che il tuo team già utilizza",
            "Salvare ore ogni settimana chiedendo invece di scavare"
        ],
        ai_screen_1_subtitle: "Il tuo lavoro di gestione della reputazione dovrebbe incontrarti dove già pensi. Chiedi a Claude o a ChatGPT cosa richiede una risposta, a chi rivolgersi successivamente o come è andata la settimana, e ricevi risposte in tempo reale senza dover cambiare strumento.",
        ai_screen_1_title: "Chiedi a Claude o ChatGPT",
        ai_screen_2_badge: "Risposte dell'IA",
        ai_screen_2_bullets: [
            "Rispondi più velocemente senza sembrare banale",
            "Non lasciare mai recensioni senza risposta quando sei occupato",
            "Proteggi la voce del tuo brand in ogni risposta pubblica."
        ],
        ai_screen_2_subtitle: "Ogni recensione senza risposta è un'occasione persa per guadagnare fiducia. L'intelligenza artificiale redige risposte che rispecchiano il tuo stile, permettendoti di smaltire la coda in pochi minuti e di rimanere a disposizione dei clienti senza dover dedicare tempo alla scrittura.",
        ai_screen_2_title: "Rispondi senza giri di parole",
        ai_screen_3_badge: "Suggerimenti dell'IA",
        ai_screen_3_bullets: [
            "Consenti a più clienti di raggiungere il traguardo",
            "Raccogli feedback specifici e condivisibili",
            "Trasforma le visite positive in recensioni degne di essere mostrate"
        ],
        ai_screen_3_subtitle: "Molte persone intendono lasciare una recensione ma non lo fanno mai. Fornisci loro un linguaggio chiaro e personale, in modo che più persone completino la recensione e che ciò che scrivono sia abbastanza incisivo da poter essere messo in evidenza.",
        ai_screen_3_title: "Ottieni più recensioni a 5 stelle",
        ai_screen_4_badge: "Etichettatura AI",
        ai_screen_4_bullets: [
            "Individua gli schemi prima che diventino problemi",
            "Trova i temi che effettivamente influenzano gli ascolti",
            "Evita di leggere centinaia di recensioni a mano"
        ],
        ai_screen_4_subtitle: "Non dovresti essere costretto a rileggere ogni recensione per capire cosa sta succedendo. L'intelligenza artificiale organizza i feedback in base ai temi che ti interessano, permettendoti di risolvere i problemi più rapidamente e di concentrarti su ciò che i clienti apprezzano.",
        ai_screen_4_title: "Scopri cosa dicono i clienti",
        ai_summary_1_desc: "Scrivi bozze di risposte Google e Facebook che si adattino al tuo tono, oppure imposta la risposta automatica in base a una programmazione.",
        ai_summary_1_title: "Risposte dell'IA",
        ai_summary_2_desc: "Offri ai clienti suggerimenti di recensione pronti all'uso quando lasciano un feedback sulla tua pagina.",
        ai_summary_2_title: "suggerimenti per la revisione dell'IA",
        ai_summary_3_desc: "Metti in evidenza le frasi più efficaci nelle recensioni positive tramite widget, vetrine e condividi immagini.",
        ai_summary_3_title: "Punti salienti dell'IA",
        ai_summary_4_desc: "Applica i etichette in base alle regole che definisci, in modo che temi come i tempi di attesa o la qualità del servizio rimangano organizzati.",
        ai_summary_4_title: "Etichettatura automatica tramite IA",
        ai_summary_5_desc: "Ricevi riassunti concisi delle recensioni più recenti, con dati, temi principali e problematiche su cui vale la pena intervenire.",
        ai_summary_5_title: "Riepiloghi Recensione",
        ai_summary_6_desc: "Individua gli elogi crescenti e le critiche emergenti senza dover leggere manualmente ogni singola recensione.",
        ai_summary_6_title: "Tendenze positive e negative",
        ai_summary_7_desc: "Trova recensioni simili accanto a ogni feedback, in modo da poter individuare facilmente schemi e ripetizioni.",
        ai_summary_7_title: "recensioni correlate",
        ai_summary_8_desc: "Poni domande in linguaggio semplice riguardo alle tue recensioni e ottieni risposte con citazioni che puoi aprire.",
        ai_summary_8_title: "Chiedi all'IA",
        ai_summary_9_desc: "Collega Claude, ChatGPT e altri client MCP per gestire la reputazione nelle chat.",
        ai_summary_9_title: "MCP per assistenti",
        ai_summary_10_desc: "Ottieni report di reputazione in tempo reale che includono volume, valutazioni, posizioni, risposte e interazioni.",
        ai_summary_10_title: "Rapporti sulla reputazione",
        ai_summary_11_desc: "Guida il tono, le parole chiave e le istruzioni personalizzate in modo che ogni output dell'IA rispecchi il tuo marchio.",
        ai_summary_11_title: "Intelligenza artificiale consapevole del marchio",
        ai_summary_12_desc: "Valuta quanto le recensioni scritte siano positive o negative, oltre le stelle, così puoi ordinare ciò che merita attenzione.",
        ai_summary_12_title: "Sentiment",
        industries: {
            accountants: "Commercialisti",
            auto_repair: "Meccanici auto",
            chiropractors: "Chiropratici",
            camps: "Campi estivi",
            cleaning: "Addetti alle pulizie",
            contractors: "Appaltatori",
            dentists: "Dentisti",
            doctors: "Medici",
            electricians: "Elettricisti",
            financial_advisors: "Consulenti finanziari",
            hvac: "Tecnici della climatizzazione",
            insurance_brokers: "Broker assicurativi",
            landscapers: "Giardinieri",
            law_firms: "Avvocati",
            locksmiths: "Fabbri",
            mortgage_brokers: "Broker mutui",
            optometrists: "Optometristi",
            personal_trainers: "Personal trainer",
            pest_control: "Disinfestatori",
            physical_therapists: "Fisioterapisti",
            plumbers: "Idraulici",
            real_estate: "Agenti immobiliari",
            restaurants: "Ristoratori",
            salons: "Parrucchieri",
            self_storage: "Operatori di self-storage",
            spas: "Estetisti",
            preschools: "Scuole materne",
            tour_guides: "Guide turistiche",
            veterinarians: "Veterinari"
        },
        industries_title: "Gestione delle recensioni per le imprese di servizi locali",
        stat_1_article: "Rapporto di ricerca sui consumatori",
        stat_1_desc: "Le persone desiderano più di 100 recensioni prima di fidarsi di un'azienda online.",
        stat_1_source: "Salsify",
        stat_1_title: "Le Recensioni conquistano la fiducia",
        stat_2_article: "Sondaggio locale Recensione dei consumatori",
        stat_2_desc: "I clienti che confrontano le attività commerciali locali preferiscono quelle che rispondono a tutte le recensioni.",
        stat_2_source: "BrightLocal",
        stat_2_title: "Scegli chi risponde",
        stat_3_article: "Recensioni, reputazione e fatturato",
        stat_3_desc: "Un piccolo incremento di punteggio può significare un reale aumento dei tuoi guadagni.",
        stat_3_source: "Harvard Business School",
        stat_3_title: "Ricavo per stella",
        stat_4_article: "Affidamento dei consumatori ai risultati di ricerca basati sull'intelligenza artificiale",
        stat_4_desc: "Quando le persone chiedono all'IA quale scegliere, le tue recensioni contribuiscono a scrivere la risposta.",
        stat_4_source: "Bain & Company",
        stat_4_title: "Affidati alla ricerca basata sull'intelligenza artificiale.",
        subtitle: "Richiedi recensioni in modalità pilota automatico. Ottieni più valutazioni a 5 stelle. Posizionati più in alto rispetto alla concorrenza.",
        agencies_screen_1_badge: "Portale",
        agencies_screen_1_bullets: [
            "Vendi un portale brandizzato con ogni contratto di abbonamento",
            "Mantieni i clienti all'interno del tuo ecosistema, non tramite un sistema di accesso di terze parti.",
            "Sembrare un'azienda di software, senza però costruirne una"
        ],
        agencies_screen_1_subtitle: "Dai a ogni cliente un portale che sembra un prodotto che hai creato tu: il tuo logo, i tuoi colori, il tuo dominio. Poi impacchetta la gestione delle recensioni come un servizio ricorrente a cui accedono ogni mese. Non stai raccomandando uno strumento. Ne stai consegnando uno.",
        agencies_screen_1_title: "Un portale che pensano tu abbia creato",
        agencies_screen_2_badge: "Controllare",
        agencies_screen_2_bullets: [
            "Abbina le funzionalità ai pacchetti base, di crescita e premium.",
            "Invita le persone giuste e controlla ciò che vede ogni cliente",
            "Sovrascrivi richieste, posizioni e limiti per progetto"
        ],
        agencies_screen_2_subtitle: "Non tutti i clienti devono avere tutto. Invita i team a progetti specifici, imposta i ruoli e sovrascrivi funzioni e limiti per account così i tuoi pacchetti coincidono con come fatturi. Fai upsell dell’accesso man mano che crescono, senza build su misura per ogni pacchetto.",
        agencies_screen_2_title: "Controlla l’accesso per cliente",
        agencies_screen_3_badge: "IA",
        agencies_screen_3_bullets: [
            "Offri risposte basate sull'intelligenza artificiale che consentono ai clienti salvare ore ogni settimana.",
            "Collega Claude o altri assistenti tramite MCP di ciascun progetto.",
            "Commercializzare l'intelligenza artificiale come componente aggiuntivo premium per i clienti."
        ],
        agencies_screen_3_subtitle: "Non limitarti a gestire le recensioni. Dai ai clienti un’AI che bozza risposte, tagga il feedback e lavora tramite Claude o altri assistenti via server MCP del progetto. È una capacità moderna che le agenzie possono pacchettizzare, upsellare e rinnovare, senza un team di contenuti per ogni account.",
        agencies_screen_3_title: "AI per cui i clienti pagheranno",
        agencies_screen_4_badge: "Scala",
        agencies_screen_4_bullets: [
            "Gestisci le recensioni di diverse aziende da un unico account.",
            "Aggiungi località man mano che le conquisti, con prezzi agevolati per acquisti in volume.",
            "Trasforma ogni nuovo cliente in entrate ricorrenti"
        ],
        agencies_screen_4_subtitle: "Un posto agenzia. Decine di attività. Gestisci raccolta recensioni, risposte e reporting su ogni sede cliente da un unico hub, poi aumenta il margine aggiungendo account. Così le agenzie trasformano la reputazione in un flusso di ricavi scalabile, non in un progetto una tantum.",
        agencies_screen_4_title: "Scala su ogni cliente",
        agencies_summary_10_desc: "Metti in contatto Claude o altri assistenti per gestire progetti, clienti e team.",
        agencies_summary_10_title: "Agenzia MCP",
        agencies_summary_11_desc: "Ogni cliente riceve il kit completo di strumenti per le recensioni: raccolta dati, intelligenza artificiale, widget e altro ancora.",
        agencies_summary_11_title: "Tutto ciò che riguarda gli affari",
        agencies_summary_12_desc: "Ricevi assistenza da un team che comprende i flussi di lavoro delle agenzie e le implementazioni presso i clienti.",
        agencies_summary_12_title: "Supporto dedicato",
        agencies_summary_1_desc: "I Clienti gestiscono la propria reputazione tramite un portale che si presenta come un prodotto sviluppato da voi.",
        agencies_summary_1_title: "Portale clienti personalizzato",
        agencies_summary_2_desc: "Gestisci il portale sul tuo dominio in modo che ogni accesso rimanga associato al tuo marchio.",
        agencies_summary_2_title: "Dominio dell'agenzia personalizzata",
        agencies_summary_3_desc: "Consenti ai clienti di accedere con il tuo provider di identità con un solo clic.",
        agencies_summary_3_title: "Accesso singolo",
        agencies_summary_4_desc: "Invita i clienti a progetti specifici e controlla ciò che possono visualizzare.",
        agencies_summary_4_title: "Inviti e ruoli Client",
        agencies_summary_5_desc: "Limita le richieste, le posizioni e le funzionalità per progetto in base ai tuoi pacchetti.",
        agencies_summary_5_title: "Sovrascritture per progetto",
        agencies_summary_6_desc: "Consenti al tuo team interno l'accesso completo a tutti i progetti dei clienti.",
        agencies_summary_6_title: "Posti a sedere per il team dell'agenzia",
        agencies_summary_7_desc: "Inizia con 5 sedi, poi aggiungine altre con prezzi maggiorati in base al volume man mano che cresci.",
        agencies_summary_7_title: "scala multi-localizzazione",
        agencies_summary_8_desc: "Notifiche di sistema inviate dal dominio della tua agenzia e, per ogni progetto, qualora i clienti non abbiano aggiunto le proprie.",
        agencies_summary_8_title: "Invio in white label",
        agencies_summary_9_desc: "Automatizza progetti, clienti e team con l' API Agency.",
        agencies_summary_9_title: "API dell'agenzia",
        demo_footer: "Scegli un orario che fa per te. Ti guideremo in tutto e risponderemo alle tue domande.",
        desc_contact: "Hai una domanda o ti serve aiuto con qualcosa? Invia un messaggio qui sotto e pensiamo noi al resto.",
        mcp_aria: "Demo dell'assistente AI collegata a More Good Reviews tramite MCP",
        mcp_prompts_aria: "Esempi di richieste",
        review_flow_aria: "Carosello di schede che mostra le richieste di recensione via e-mail, la pagina delle recensioni, le recensioni Google e i feedback privati.",
        review_flow_autopilot: "Funziona con il pilota automatico",
        review_flow_card_email_desc: "Una volta terminata la sessione con un cliente, inviamo automaticamente un'email di richiesta personalizzata con il tuo marchio e un link che ti reindirizza con un solo clic alla tua pagina di recensioni.",
        review_flow_card_email_title: "Invia la richiesta",
        review_flow_card_feedback_desc: "Le valutazioni più basse consentono prima di visualizzare i feedback privati, in modo da poter rimediare. I Clienti possono comunque scegliere di lasciare una recensione pubblica.",
        review_flow_card_feedback_title: "Accettare feedback costruttivi",
        review_flow_card_google_desc: "I clienti soddisfatti hanno a disposizione un modo semplice per lasciare una recensione pubblica Google , in modo che i commenti positivi siano visibili proprio dove i nuovi clienti cercano le loro opinioni.",
        review_flow_card_google_title: "Esprimi il tuo apprezzamento a Google",
        review_flow_card_review_desc: "Arrivano sulla tua pagina di recensioni, scelgono una valutazione e il passo successivo dipende da come è andata.",
        review_flow_card_review_title: "Il Cliente sceglie una valutazione",
        review_flow_next: "Passo successivo",
        review_flow_prev: "Passaggio precedente",
        review_flow_step_email: "Richiesta una Recensione",
        review_flow_step_feedback: "oppure Richiedi un feedback",
        review_flow_step_google: "Percorso verso qualsiasi sito Recensione",
        review_flow_step_review: "Richiedi Punteggio",
        review_flow_steps_aria: "Passaggi della richiesta Recensione",
        summary_10_desc: "Organizza clienti e recensioni in modo da poter filtrare e agire rapidamente.",
        summary_10_title: "Etichettatura Cliente e recensioni",
        summary_11_desc: "Zapier integra More Good Reviews negli strumenti che già utilizzi.",
        summary_11_title: "Connettiti a qualsiasi app",
        summary_12_desc: "Gestisci la reputazione con Claude, ChatGPT e altri client MCP .",
        summary_12_title: "MCP per assistenti IA",
        summary_1_desc: "Invio automatico di email e SMS programmati con promemoria.",
        summary_1_title: "Richieste di revisione automatiche",
        summary_2_desc: "Email e SMS in linea con il tuo marchio, il tuo tono di voce e la tua offerta.",
        summary_2_title: "Modelli personalizzati con il marchio",
        summary_3_desc: "Raccogli feedback privati o indirizza gli utenti a Google, Facebook e altri social network.",
        summary_3_title: "Pagine Recensione",
        summary_4_desc: "Codici stampabili e ritiro in negozio a schermo intero.",
        summary_4_title: "Codici QR e chioschi",
        summary_5_desc: "Integra valutazioni e recensioni in qualsiasi punto del tuo sito web.",
        summary_5_title: "Widget per siti web",
        summary_6_desc: "Una pagina pubblica e personalizzabile per le tue migliori recensioni.",
        summary_6_title: "Showcase vetrina",
        summary_7_desc: "Importa recensioni e rispondi da un'unica piattaforma.",
        summary_7_title: "Sincronizzazione Google e Facebook",
        summary_8_desc: "Suggerimenti visualizzati sulla pagina che aiutano i clienti a lasciare una recensione.",
        summary_8_title: "Aiuto per la stesura di recensioni sull'IA",
        summary_9_desc: "Scrivi bozze di risposte, riepiloghi, analisi delle tendenze e chiedi all'IA di commentare le tue recensioni.",
        summary_9_title: "Risposte e approfondimenti dell'IA",
        subtitle_agencies_feature_summary: "Portale white label, accesso clienti, scale e automazione sotto il tuo brand.",
        subtitle_ai_feature_summary: "Risposte, tag, analisi e assistenti integrati nel flusso di lavoro di gestione della reputazione.",
        subtitle_feature_summary: "Raccolta, visualizzazione, AI e integrazioni — pronti quando lo sei tu.",
        subtitle_mcp: "Collega Claude, ChatGPT e altri client MCP, poi chiedi di recensioni, sedi e outreach con linguaggio naturale.",
        subtitle_review_flow: "Chiedi recensioni automaticamente. I clienti possono lasciare una recensione pubblica in qualsiasi momento. Il feedback privato è opzionale.",
        title: "Gestione della reputazione con IA per",
        title_agencies: "Trasforma le recensioni in",
        title_agencies_feature_summary: "Tutto ciò di cui le agenzie hanno bisogno",
        title_agencies_phrases: {
            branded_product: "un prodotto branded di tua proprietà",
            recurring_retainers: "retainer mensili ricorrenti",
            revenue_stream: "una nuova fonte di ricavi"
        },
        title_ai: "Chiedi alla tua IA",
        title_ai_feature_summary: "Tutto ciò che l'intelligenza artificiale può fare per te",
        title_ai_phrases: {
            weekly_report: "per un rapporto settimanale sulla reputazione",
            send_from_chat: "inviare richieste di recensione",
            next_steps: "per i prossimi passi da intraprendere"
        },
        title_contact: "Come possiamo aiutarti?",
        faq_location_pricing_a: "Con Business paghi per sede con sconti a volume man mano che cresci (da 59 $\/sede\/mese, o 49 $\/mese con fatturazione annuale) e ogni sede include 5.000 richieste di recensione al mese. Agency include 5 sedi e 25.000 richieste; le sedi extra costano 12 $\/mese e ognuna aggiunge 5.000 richieste.",
        faq_location_pricing_q: "Come funziona il prezzo per sede?",
        title_faq: "Domande frequenti",
        title_feature_summary: "Tutto nel pacchetto",
        title_footer: "Smetti di rincorrere le recensioni. Inizia a ottenerle.",
        title_footer_ai: "riguardo alla tua reputazione",
        title_ltd: "Paga una volta e utilizzalo per sempre con la nostra offerta a vita a tempo limitato.",
        title_mcp: "Chiedi all’IA della tua reputazione",
        title_review_flow: "Trasforma le grandi esperienze in recensioni",
        title_phrases: {
            autopilot: "richiedere recensioni in automatico",
            google_reviews: "ottenere più recensioni Google",
            suggested_by_chatgpt: "essere suggeriti da ChatGPT"
        },
        title_pricing: "Tutte le funzionalità. Prezzi semplici.",
        title_reviews: "Non credeteci sulla parola"
    },
    plans: {
        additional_locations_tooltip: "Aggiungi sedi man mano che cresci. Business addebita ogni sede da 59 $\/mese (inclusa la prima), con una tariffa annuale più bassa. Le sedi extra Agency costano 12 $\/mese oltre alle 5 incluse e ognuna aggiunge 5.000 richieste mensili.",
        agency: {
            agency_api: "API dell'agenzia",
            branded_portal: "Portale clienti personalizzato",
            client_invites: "Inviti, ruoli e override Client",
            custom_domain: "Dominio dell'agenzia personalizzata",
            everything_in_business: "Tutto nel piano aziendale",
            locations_included: "5 località incluse",
            review_requests: "5.000 richieste di recensione \/ località \/ mese",
            sso: "Accesso singolo (SSO)",
            support: "Assistenza clienti dedicata",
            volume_pricing: "12 $\/mese per posizione extra"
        },
        business: {
            ai: "Risposte, approfondimenti e domande all'IA",
            api_mcp: "Server API e MCP",
            custom_domains: "Domini personalizzati per email e pagine di recensione",
            google_facebook: "Profilo Google Business e Facebook",
            locations_included: "1 località inclusa",
            review_requests: "{count} richieste di revisione \/ posizione \/ mese",
            support: "Assistenza clienti dedicata",
            unlimited_customers: "Clienti illimitati",
            volume_pricing: "Prezzi a partire da 59 $\/mese per acquisti in volume"
        },
        descriptions: {
            agency: "Per le agenzie che gestiscono la reputazione dei clienti con il loro marchio. Cinque sedi incluse, poi 12 $ per sede extra, oltre a un portale personalizzato e accesso clienti.",
            business: "Per le aziende che gestiscono la propria reputazione online. Paga per sede con sconti per volumi elevati e ottieni intelligenza artificiale, integrazioni e clienti illimitati inclusi."
        },
        selectors: {
            agency_extras_flat: "Posizioni extra · {price}\/{month} ciascuna",
            agency_included: "{count} posizioni incluse",
            agency_tier: "+{from}–{to} posizioni · {price}\/{month} ciascuna",
            agency_tier_plus: "+{from}+ posizioni · {price}\/{month} ciascuna",
            business_tier: "{from}–{to} posizioni · {price}\/{month} ciascuna",
            business_tier_plus: "{from}+ posizioni · {price}\/{month} ciascuna"
        }
    },
    mcp_example_prompts: {
        labels: {
            add_customer_and_ask: "Aggiungi un cliente e richiedi una recensione",
            customers_to_ask: "Trova clienti a cui chiedere recensioni",
            location_leaderboard: "Confronta le prestazioni della posizione",
            outreach_health: "Verifica lo stato di consegna delle richieste",
            review_digest: "Sintesi settimanale",
            send_review_requests: "Invia richieste di Recensione in blocco"
        },
        texts: {
            add_customer_and_ask: "Aggiungi un nuovo cliente utilizzando i dati di contatto che ti fornirò, quindi programma una richiesta di recensione via e-mail con 2 promemoria.",
            customers_to_ask: "Elenca fino a 50 clienti a cui non è mai stato chiesto di lasciare una recensione, ordinandoli per data di iscrizione, dal più recente al più vecchio. Ignora chi si è disiscritto. Includi nome, email e data di iscrizione.",
            import_customer: "Aggiungi {name} come cliente. Il suo indirizzo email è {email}.",
            import_customer_reply: "Aggiunto {name}.",
            import_review: "Aggiungi una recensione a 5 stelle da {name}: Il team è stato professionale e i risultati eccellenti.",
            import_review_reply: "Aggiunta la recensione a 5 stelle di {name}.",
            location_leaderboard: "Crea una classifica di 90 giorni per località con numero di recensioni, valutazione media, percentuale di recensioni a 5 stelle e andamento rispetto ai 90 giorni precedenti. Ordina per valutazione e segnala qualsiasi calo superiore a 0,2 stelle.",
            outreach_health: "Per i messaggi email inviati negli ultimi 14 giorni, riporta il numero totale di messaggi inviati, il tasso di consegna, il tasso di apertura, il tasso di clic e il tasso di errore. Segnala eventuali anomalie.",
            review_digest: "Riassumi tutte le recensioni degli ultimi 7 giorni. Includi il numero, la valutazione media, la suddivisione per fonte e posizione geografica, i 3 temi principali e le 3 problematiche principali.",
            send_review_requests: "Per i clienti che si sono registrati negli ultimi 30 giorni e non hanno ancora ricevuto una richiesta di recensione, programma un invio di email con due promemoria. Mostra prima l'elenco e attendi la mia conferma."
        }
    },
    messages: {
        activated: "Attivato con successo.",
        archived: "Archiviazione riuscita.",
        canceled: "Annullamento eseguito con successo.",
        cannot_copy: "Impossibile copiare negli appunti",
        cname_active: "Lo stato CNAME è attivo.",
        cname_not_active: "Lo stato CNAME non è ancora attivo.",
        connected: "Connessione riuscita.",
        cookie_banner_text: "Utilizziamo i cookie per migliorare la tua esperienza. Puoi personalizzare le tue preferenze o accettarli tutti.",
        cookie_category_analytics_desc: "Utilizzati per misurare il traffico del sito web e l'utilizzo dei prodotti. Questi cookie ci aiutano a capire come i visitatori utilizzano il nostro sito.",
        cookie_category_essential_desc: "Sempre attivi. Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati.",
        cookie_category_functional_desc: "Abilita funzionalità avanzate come la chat in tempo reale. Questi cookie non ti tracciano a fini pubblicitari.",
        cookie_category_marketing_desc: "Utilizzati per pubblicità e misurazione delle campagne. Questi possono includere pixel pubblicitari e strumenti di attribuzione.",
        copied: "Copiato correttamente.",
        copied_to_all_ratings: "Copiato in tutte le valutazioni. Salva per applicare.",
        created: "Creazione riuscita.",
        deactivated: "Disattivato con successo.",
        deleted: "Eliminato con successo.",
        disconnected: "Disconnesso con successo.",
        duplicated: "Duplicato con successo.",
        error: "Si è verificato un errore. Riprova.",
        google_connect_failed: "Non è stato possibile connettersi a Google. Puoi riprovare o saltare questo passaggio per ora.",
        inquiry_sent: "Grazie per la tua richiesta. Ti contatteremo a breve.",
        oauth_consent_intro: "{client} sta richiedendo l'autorizzazione per accedere al tuo account.",
        oauth_request_missing: "La richiesta di autorizzazione OAuth è mancante o scaduta.",
        operation_analytics_rebuild_failed: "Impossibile creare le analisi.",
        operation_analytics_rebuild_progress: "Creazione delle tue analisi…",
        operation_analytics_rebuild_success: "Le analisi sono pronte.",
        operation_connection_sync_failed: "Sincronizzazione {integration_name} non riuscita.",
        operation_connection_sync_progress: "Sincronizzazione {integration_name}…",
        operation_connection_sync_success: "Sincronizzazione {integration_name} completata.",
        operation_customer_import_failed: "Importazione Cliente non riuscita.",
        operation_customer_import_progress: "Importazione clienti…",
        operation_customer_import_success: "Importazione Cliente completata.",
        operation_review_import_failed: "Importazione Recensione non riuscita.",
        operation_review_import_progress: "Importazione recensioni…",
        operation_review_import_success: "Recensione dell'importazione completata.",
        operation_review_scrape_failed: "L'importazione della recensione recente non è riuscita.",
        operation_review_scrape_progress: "Importazione recensioni recenti…",
        operation_review_scrape_success: "Importazione della recensione recente completata.",
        processed: "Elaborazione eseguita correttamente.",
        published: "Pubblicato con successo.",
        purchased: "Acquistato con successo.",
        queued: "Programmato con successo.",
        refreshed: "Aggiornato con successo.",
        removed: "Rimosso con successo.",
        resubscribed: "Nuova iscrizione effettuata con successo.",
        revoked: "Revoca effettuata con successo.",
        saved: "salvato con successo.",
        scheduled: "Programmato con successo.",
        sent: "Invio effettuato con successo.",
        started: "Avviato con successo.",
        stopped: "Arrestato con successo.",
        sso_failed: "Impossibile autorizzare l'accesso tramite SSO.",
        sso_invalid_callback: "Callback SSO non valido.",
        sso_not_configured: "L'SSO non è configurato.",
        sso_openid_config_failed: "Impossibile caricare la configurazione OpenID.",
        sso_token_exchange_failed: "Impossibile completare lo scambio dei token SSO.",
        subscribed: "Iscrizione effettuata con successo.",
        suspended: "Sospeso con successo.",
        synced: "Sincronizzazione eseguita correttamente.",
        unarchived: "Ripristino dall'archivio riuscito.",
        unpublished: "Pubblicazione annullata con successo.",
        unscheduled: "Rimozione dalla programmazione riuscita.",
        unsubscribed: "Annullamento dell'iscrizione riuscito.",
        unsuspended: "Ripristino della sospensione riuscito.",
        updated: "Aggiornato con successo.",
        upgraded: "Aggiornamento eseguito con successo.",
        validated: "Convalidato con successo.",
        verified: "Verificato con successo."
    },
    notices: {
        agency: "Gestisci un'agenzia? Puoi offrire il nostro prodotto in white label in modo che i tuoi clienti vedano solo il tuo marchio quando utilizzano il servizio.",
        ai_tags: "Crea un tag IA così le recensioni che corrispondono alle istruzioni vengono etichettate automaticamente.",
        connected_apps: "Le app che colleghi tramite MCP verranno visualizzate qui.",
        connector: "Importa i tuoi clienti da migliaia di applicazioni con {brand}.",
        customer_messages: "Richiedi una Recensione per programmare i messaggi.",
        customer_reviews: "Richiedi una recensione a questo cliente.",
        customers: "Importa i tuoi clienti per iniziare a richiedere recensioni.",
        customers_import_yourself: "Importa i tuoi clienti per iniziare a richiedere recensioni. Puoi anche importare prima te stesso per provare l'esperienza prima di invitare altri.",
        external_links: "Aggiungi link esterni al tuo portale clienti per aiutarti a vendere i tuoi servizi. Questi link saranno mostrati ai tuoi clienti nella barra laterale.",
        links: "Aggiungi pulsanti alla tua pagina per lasciare recensioni su siti web di terze parti.",
        locations: "Crea una posizione in modo da poter attribuire le recensioni a più posizioni.",
        ltd: "Sblocca l'accesso a vita con il tuo codice di accesso. Ogni codice è dotato di un numero limitato di richieste mensili, più tutte le funzionalità. I codici sono cumulabili. 3 o più codici sbloccano il piano agency. Inserisci i tuoi codici di accesso qui sotto.",
        mcp_example_prompts: "Una volta stabilita la connessione al server MCP , incolla questi dati nel tuo assistente come punto di partenza.",
        messages: "Ogni richiesta e promemoria verrà visualizzato qui quando ai tuoi clienti verrà richiesta una recensione.",
        no_commissions: "Non hai ancora guadagnato commissioni.",
        no_payouts: "I pagamenti vengono inviati manualmente una volta che il saldo approvato raggiunge almeno $50,00 e il conto bancario è collegato.",
        no_projects: "Non ti è ancora stato assegnato un progetto. Contatta l’amministratore per ottenere l’accesso.",
        no_referrals: "Non hai ancora invitato nessuno. Condividi il tuo link di invito per iniziare.",
        qr_codes: "Crea codici QR con colori, posizioni e etichette personalizzati. Scaricali in formato SVG o PNG.",
        referrals_share_subject: "Il mio gestore di reputazione basato sull'IA",
        referrals_share_text: "La mia arma segreta per ottenere recensioni per la tua attività: More Good Reviews. Gestione della reputazione tramite intelligenza artificiale che funziona davvero. Iscriviti tramite il mio link:",
        review_pages: "Il tuo progetto può avere più pagine di recensioni in cui i tuoi clienti possono lasciare recensioni. Questo è utile per le aziende con più di una sede.",
        reviews: "Aspettiamo le recensioni dei tuoi clienti.",
        showcase: "Abbiamo appena iniziato.",
        signatures: "Crea una firma email da copiare e incollare nella tua applicazione di posta elettronica.",
        sources: "Crea una fonte per poter categorizzare le tue recensioni.",
        tag_rules: "Crea una regola per categorizzare automaticamente le tue recensioni tramite l'intelligenza artificiale.",
        tags: "Crea un'etichetta per categorizzare le tue recensioni e i tuoi clienti.",
        unauthorized: "Non hai l'autorizzazione per accedere a questa pagina.",
        unsubscribed: "Ora sei stato annullato dall'iscrizione alle richieste di Recensione.",
        webhooks: "Aggiungi webhook per ricevere notifiche sugli eventi della piattaforma.",
        widgets: "Crea widget per incorporare le recensioni sul tuo sito web.",
        your_referral_link_text: "Condividi il tuo link per guadagnare una commissione ricorrente del {rate}% su ogni pagamento effettuato dai clienti che hai segnalato. I pagamenti vengono inviati manualmente una volta che il tuo saldo approvato raggiunge almeno $50,00."
    },
    notification_types: {
        descriptions: {
            imports: "Inviato al completamento delle importazioni",
            new_reviews: "Inviato quando vengono ricevute le recensioni",
            sent_replies: "Inviato quando alle recensioni viene data risposta automaticamente",
            weekly_reports: "Un riepilogo delle attività inviato settimanalmente"
        },
        names: {
            imports: "Importazioni",
            new_reviews: "Nuove Recensioni",
            sent_replies: "Risposte inviate",
            weekly_reports: "Rapporti settimanali"
        }
    },
    roles: {
        admin: "Amministratore",
        manager: "Manager",
        operator: "Operatore",
        owner: "Proprietario",
        super_admin: "Super amministratore",
        viewer: "Spettatore"
    },
    tasks: {
        automate: "Turn on automatic review requests and reminders. Each customer is contacted once, and can unsubscribe anytime.",
        customers: "Import customers with names and email or phone — manually, via Stripe, HubSpot, app connectors, the API, or by BCC’ing your project email on invoices.",
        google: "Connect Google Business Profile to import reviews, keep them in sync, and reply from here.",
        review_page: "Customize the page that captures reviews and can send customers to third-party sites — text, layout, fields, links, and redirects.",
        strategy: "Choose when customers are asked for reviews. We’ve set a simple default you can change anytime.",
        templates: "Edit the request and reminder emails customers receive. Both include one-click ratings, plus your logo and branding."
    },
    titles: {
        accept_invite: "Accetta invito",
        accepting_invite: "Accettazione dell'invito",
        access_denied: "Accesso negato",
        account: "Account",
        actions: "Azioni",
        add_custom_field: "Aggiungi campo personalizzato",
        add_ons: "Componenti aggiuntivi",
        address: "Indirizzo",
        agencies: "Agenzie",
        agency: "Agenzia",
        ai: "IA",
        ai_assistant: "Assistente AI",
        ai_highlights: "Punti salienti dell'IA",
        ai_replies: "Risposte AI",
        ai_review_suggestions: "Suggerimenti Recensione dell'IA",
        ai_tags: "Tag IA",
        ai_tools: "Strumenti IA",
        analytics: "Analisi",
        api: "API",
        api_key: "Chiave API",
        appearance: "Aspetto",
        application_connectors: "Connettori applicativi",
        attributes: "Attributi",
        authorize: "Autorizzare",
        auto_tagging: "Etichettatura automatica",
        automate: "Automatizza",
        automatic_review_collection: "Raccolta automatica Recensione",
        billing: "Fatturazione",
        branding: "Marchio",
        change_password: "Cambiare la password",
        clients: "Clienti",
        cname: "CNAME",
        conditions: "Condizioni",
        confirmation_message: "Messaggio di conferma",
        connected_apps: "App connesse",
        contact_us: "Contattaci",
        cookie_policy: "Politica sui cookie",
        cookie_preferences: "Preferenze sui cookie",
        copy: "Copia",
        create_your_account: "Crea il tuo account",
        crms: "CRMs",
        css: "CSS",
        custom_field: "Campo personalizzato",
        custom_fields: "Campi personalizzati",
        custom_icons: "Icone personalizzate",
        customer: "Cliente",
        customer_facing_pages: "Pagine rivolte al cliente",
        customers: "Clienti",
        dashboard: "Cruscotto",
        details: "Dettagli",
        dmarc: "DMARC",
        domain: "Dominio",
        dpa: "Accordo sul trattamento dei dati",
        dsar: "Richiesta di accesso ai dati da parte dell'interessato",
        email_address: "Indirizzo e-mail",
        email_messages: "Messaggi di posta elettronica",
        email_settings: "Impostazioni e-mail",
        email_usage: "Utilizzo della posta elettronica",
        emails: "E-mail",
        embed_code: "Codice incorporato",
        example_chat: "Esempio di chat",
        examples: "Esempi",
        export: "Esportare",
        external_link: "Collegamento esterno",
        external_link_num: "Collegamento esterno #{num}",
        external_links: "Collegamenti esterni",
        features: "Funzionalità",
        feedback_form: "Modulo di feedback",
        field: "Campo",
        fields: "Campi",
        filters: "Filtri",
        form_fields: "Campi del modulo",
        got_access_code: "Hai un codice di accesso?",
        hipaa: "Dichiarazione HIPAA",
        how_it_works: "Come funziona",
        incentive: "Incentivo",
        instructions: "Istruzioni",
        integration: "Integrazione",
        integrations: "Integrazioni",
        javascript: "JavaScript",
        latest_reviews: "Ultime Recensioni",
        location_leaderboard: "Classifica sedi",
        lifetime_deal: "Offerta a vita",
        limits: "Limiti",
        link: "Collegamento",
        links: "Collegamenti",
        location: "Posizione",
        location_picker: "Selettore di posizione",
        locations: "Posizioni",
        log_in: "Login",
        log_out: "Esci",
        make_default: "Rendi predefinito",
        manage_limits: "Gestisci limiti",
        manage_overrides: "Gestisci override",
        manage_review: "Gestisci Recensione",
        mcp_example_prompts: "Esempi di richieste",
        mcp_server: "Server MCP",
        message: "Messaggio",
        messages: "Messaggi",
        meta: "Meta",
        no_clients: "Nessun cliente",
        no_commissions: "Nessuna commissione",
        no_connected_apps: "Nessuna app connessa",
        no_custom_fields: "Nessun campo personalizzato",
        no_customers: "Nessun cliente",
        no_links: "Nessun Collegamenti",
        no_locations: "Nessuna posizione",
        no_members: "Nessun membro",
        needs_attention: "Richiede attenzione",
        no_messages: "Nessun messaggio",
        no_payouts: "Nessun pagamento",
        no_projects: "Nessun progetto",
        no_qr_codes: "Nessun codice QR",
        no_referrals: "Nessun referral",
        no_review_pages: "Nessuna Pagine di Recensione",
        no_reviews: "Nessuna Recensioni",
        no_tags: "Nessun Etichette",
        no_team_members: "Nessun membro del team",
        no_template: "Nessun modello",
        no_widgets: "Nessun widget",
        notifications: "Notifiche",
        options: "Opzioni",
        overview: "Panoramica",
        payment_method: "Metodo di pagamento",
        photo: "Foto",
        plans: "Piani",
        powered_by: "Offerto da",
        pricing: "Prezzi",
        privacy_policy: "politica sulla riservatezza",
        profile: "Profilo",
        project: "Progetto",
        project_limits: "Limiti del progetto",
        project_overrides: "Sostituzioni del progetto",
        projects: "Progetti",
        qr_code: "Codice QR",
        qr_codes: "Codici QR",
        ratings: "Valutazioni",
        redeem_access_code: "Riscatta il codice di accesso",
        redirecting: "Reindirizzamento",
        redirects: "Reindirizzamenti",
        referrals_commissions: "Commissioni",
        referrals_payouts: "Pagamenti",
        referral_program: "Termini e condizioni del programma di segnalazione",
        reminders: "Promemoria",
        reply: "Rispondere",
        request: "Richiesta",
        request_options: "Opzioni di richiesta",
        requests: "Richieste",
        required: "Necessario",
        reschedule_message: "Riprogramma messaggio",
        reset_password: "Reimposta password",
        resource_limits: "Limiti delle risorse",
        retries: "Nuovi tentativi",
        review: "Recensione",
        review_link: "Collegamento Recensione",
        review_page: "Pagina di recensione",
        review_pages: "Pagine di recensione",
        review_spotlight: "Recensione in evidenza",
        review_suggestions: "Suggerimenti Recensione",
        review_wall: "Muro di recensioni",
        review_velocity: "Recensioni a settimana",
        reviewer: "Autore della recensione",
        reviews: "Recensioni",
        save_changes: "Salvare modifiche",
        schedule: "Programma",
        scrape_a_website: "Estrai da un sito web",
        search_engines: "Motori di ricerca",
        sections: "Sezioni",
        select_csv_file: "Seleziona file CSV",
        select_project: "Seleziona un progetto",
        selecting_project: "Selezione del progetto",
        sending_domain: "Dominio di invio",
        sending_limits: "Limiti di invio",
        sentiment: "Sentiment",
        settings: "Impostazioni",
        setup: "Impostare",
        setup_basics: "La tua strategia Richiesta",
        setup_business: "Iniziamo",
        setup_google: "Il tuo profilo Google Business",
        setup_trusted: "Scelto da oltre 5.000 aziende",
        showcase: "Showcase",
        sign_up: "Iscrizione",
        signature: "Firma email",
        signatures: "Firme email",
        signing_in: "Accesso",
        single_sign_on: "Accesso unico",
        slug: "Slug",
        sms: "SMS",
        sms_messages: "Messaggi SMS",
        sms_usage: "Utilizzo SMS",
        smtp_configuration: "Configurazione SMTP",
        source: "Fonte",
        sources: "Fonti",
        star_mix: "Ripartizione valutazioni",
        space: "Spazio di lavoro",
        spaces: "Spazi di lavoro",
        stats: "Statistiche",
        sub_processors: "Sottoprocessori",
        success_page: "Pagina di successo",
        summary: "Riepilogo",
        tag: "Etichetta",
        tag_rule: "Regola dei tag",
        tags: "Etichette",
        team_members: "Membri del team",
        template: "Modello",
        templates: "Modelli",
        terms_of_service: "Termini di servizio",
        two_factor_authentication: "Autenticazione a due fattori",
        unable_to_complete_request: "Impossibile completare la richiesta",
        unique_review_link: "Collegamento Recensione univoco",
        unsent_messages: "Messaggi non inviati",
        unsubscribe: "Annulla iscrizione",
        update_plan: "Aggiorna il piano",
        usage: "Utilizzo",
        user: "Utente",
        user_info: "Informazioni utente",
        verify_email_address: "Verifica indirizzo email",
        verifying_email: "Verifica email",
        visibility: "Visibilità",
        webhook: "Webhook",
        webhooks: "Webhook",
        website: "Sito web",
        white_label_api: "API white label",
        white_label_client_portal: "Portale clienti White Label",
        white_label_image_urls: "URL delle immagini White Label",
        white_label_sending_domain: "Dominio di invio White Label",
        white_label_widget_tag: "Tag widget etichetta bianca",
        widget: "Widget",
        widget_num: "Elemento #{num}",
        widgets: "I widget",
        your_plan: "Il tuo piano"
    },
    tones: {
        apologetic: "Scusato",
        casual: "Casuale",
        empathetic: "Empatico",
        enthusiastic: "Entusiasta",
        formal: "Formale",
        friendly: "Amichevole",
        grateful: "Grato",
        humorous: "Umoristico",
        informative: "Informativo"
    },
    widgets: {
        labels: {
            alignment: "Allineamento",
            animation: "Animazione",
            autoplay: "Riproduzione automatica",
            autoplay_delay: "Ritardo di riproduzione automatica",
            avatar: "L'Avatar",
            background_color: "Colore di sfondo",
            border: "Confine",
            border_color: "Colore del bordo",
            border_radius: "Raggio del bordo",
            border_width: "Larghezza del bordo",
            carousel: "Carousel",
            colors: "Colori",
            company: "Azienda",
            customer: "Cliente",
            customer_position: "Posizione del cliente",
            date: "Data",
            delay: "Ritardo",
            design: "Design",
            design_prompt_placeholder: "Esempio: Morbido e minimalista, con stelle dorate e angoli arrotondati.",
            drop_shadow: "Ombra portata",
            duration: "Durata",
            filters: "Filtri",
            font: "Font",
            font_emphasis: "Enfasi del carattere",
            font_family: "Famiglia di caratteri",
            font_size: "Dimensione del carattere",
            include_hidden: "Includi Recensioni nascoste",
            layout: "Disposizione",
            limit: "Recensioni per pagina",
            location_ids: "Posizioni",
            marquee: "Marquee",
            max_slides: "Diapositive massime",
            max_width: "Larghezza massima",
            name_convention: "Nome",
            padding: "Spaziatura interna",
            pagination: "Paginazione",
            quotes: "Citazioni",
            rating: "Punteggio",
            rating_round: "Arrotondamento",
            rating_round_hundredth: "Centesimo più vicino (4,94)",
            rating_round_tenth: "Decimo più vicino (4,9)",
            review: "Recensione",
            review_chars: "Lunghezza Recensione",
            review_count: "Numero di Recensione",
            review_id: "Recensione",
            review_ids: "Recensioni",
            review_ids_for_faces: "Recensioni per Faces",
            reviews: "Recensioni",
            schema: "Schema",
            schema_name: "Nome dell'azienda",
            schema_type: "Tipo di attività",
            score: "Valutazione più bassa",
            show_on_mobile: "Mostra su dispositivi mobili",
            slider: "Cursore",
            sort: "Ordinare",
            source: "Fonte",
            source_ids: "Fonti",
            source_position: "Posizione della sorgente",
            speed: "Velocità",
            star_color: "Colore della stella",
            star_display: "Esposizione di stelle",
            star_size: "Dimensione della stella",
            star_spacing: "Star Spacing",
            star_style: "Star Style",
            star_style_classic: "Classic",
            star_style_sharp: "Sharp",
            tag_ids: "Etichette",
            take: "Numero massimo di Recensioni",
            text_color: "Colore del testo",
            truncate: "Abbreviare la Recensione",
            visible_slides: "Diapositive visibili",
            width: "Larghezza"
        },
        types: {
            badge: "Distintivo",
            carousel: "Carousel",
            carousel_dynamic: "Carosello dinamico",
            corner: "Angolo",
            corner_dynamic: "Angolo dinamico",
            faces: "Volti",
            headline: "Titolo",
            highlights: "Punti salienti",
            marquee: "Marquee",
            spotlight: "In evidenza",
            wall: "Muro"
        }
    }
}